// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-01T17:24:19.719Z
// Property: The Gates at South Bend (ID: 6767906449167335)
// Collections: 22 amenities, 4 floorplans (live), 37 photos, 41 POIs, 8 reviews, 1 virtual tours, 5 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162258",
  "multihub_property_id": "6767906449167335",
  "property_external_id": "100160115",
  "property_zillow_url": "https://www.zillow.com/apartments/tuscaloosa-al/gates-at-south-bend/CknqVf/",
  "property_apartments_url": "https://www.apartments.com/the-gates-at-south-bend-tuscaloosa-al/gstfnpz/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Gates+At+South+Bend/data=!4m2!3m1!1s0x0:0x4c7117166c091071?sa=X&ved=1t:2428&ictx=111",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-gates-at-south-bend",
  "property_name": "The Gates at South Bend",
  "property_website_url": "https://www.gatesatsouthbend.com/",
  "property_domain": "https://www.gatesatsouthbend.com/",
  "property_address": "3831 3rd E Ave",
  "property_full_address": "3831 3rd Ave E, Tuscaloosa, AL 35405",
  "property_address_1": "3831 3rd Ave E",
  "property_address_2": null,
  "property_address_city": "Tuscaloosa",
  "property_address_state": "AL",
  "property_address_zip_full": null,
  "property_address_zip": "35405",
  "property_address_country": "US",
  "property_address_county": "Tuscaloosa County",
  "property_neighborhood_address": "West Tuscaloosa",
  "property_address_latitude": "33.1723533",
  "property_address_longitude": "-87.5320488",
  "property_email": null,
  "property_phone": "(205) 539-6839",
  "property_call_tracking_phone": "866-613-6287",
  "property_company_name": "Axia Residential (ARC Living)",
  "property_company_url": "https://www.axiares.com/",
  "agency_contacts": null,
  "property_type": "Apartment",
  "property_short_description": "Welcome to The Gates at South Bend in vibrant Tuscaloosa, AL, where comfort meets convenience. Choose from spacious two and three-bedroom floor plans featuring modern amenities like a stunning model home, inviting picnic areas, and a playground. Your new home awaits!",
  "property_long_description": "Welcome to The Gates at South Bend, your ideal apartment community nestled in the heart of Tuscaloosa, AL. With a variety of spacious floor plans, including two and three-bedroom options, we cater to your lifestyle and needs. Our well-maintained grounds create a picturesque environment designed for relaxation, while our model home offers a glimpse into the comfort you can call your own. Experience the convenience of our exceptional amenities, which include access gates for added security and an attentive on-site management team. Whether you’re enjoying a sunny day at our picnic area, watching your children play in our playground, your happiness is our priority. Each apartment comes equipped with modern features such as stackable washer and dryer units, new carpet, and beautiful wood-style flooring for a stylish touch. With both 1st and 2nd floor availability, finding the perfect layout is easy. Discover why The Gates at South Bend is the perfect choice for those seeking comfort and community in Tuscaloosa. Don't miss the opportunity to find your new home today! Browse our availability or schedule a tour to visit our vibrant community and experience all that we have to offer!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d782f-ef76-71fd-8107-3db05024aa36.webp",
  "property_featured_image_media": {
    "alt_text": "The Gates at South Bend monument sign and exterior view of townhomes.",
    "public_id": "019d782f-ef76-71fd-8107-3db05024aa36",
    "storage_key": "property/6767906449167335/019d782f-ef76-71fd-8107-3db05024aa36.webp",
    "width": 1280,
    "height": 989
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "146",
  "property_year_built": "2022",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "100",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Security Deposit (Refundable)\n$300.00",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Maximum 2 pets per unit. Breed restrictions apply.",
  "property_pet_policy_description": "Cats and dogs allowed. Maximum 2 pets per unit. Monthly pet rent: $70 per pet. One-time pet fee: $300–$600 per pet. Breed restrictions apply.",
  "property_petpolicy_info": "Pet Policy\nPet Types: Cats & Dogs\nBreed Restrictions Apply",
  "property_online_leasing_url": "https://gatesatsouthbendaxia.prospectportal.com/Tuscaloosa/Gates at South Bend",
  "property_resident_portal_url": "https://gatesatsouthbendaxia.residentportal.com/auth",
  "property_apply_now_url": "https://gatesatsouthbendaxia.prospectportal.com/Apartments/module/application_authentication/popup/false/kill_session/1/property/100160115/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-a6e4-74ad-8dc6-b705cce88172.webp",
  "property_primary_logo_media": {
    "alt_text": "The Gates at South Bend logo",
    "public_id": "019d54f5-a6e4-74ad-8dc6-b705cce88172",
    "storage_key": "property/6767906449167335/019d54f5-a6e4-74ad-8dc6-b705cce88172.webp",
    "width": 272,
    "height": 75
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019df438-0904-77bd-a89b-85c68f74db69.webp",
  "property_fav_icon_media": {
    "alt_text": "G logo",
    "public_id": "019df438-0904-77bd-a89b-85c68f74db69",
    "storage_key": "property/6767906449167335/019df438-0904-77bd-a89b-85c68f74db69.webp",
    "width": 1181,
    "height": 1181
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-efc3-7192-8cba-4c845fdc658d.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019d54f5-efc3-7192-8cba-4c845fdc658d",
    "storage_key": "property/6767906449167335/019d54f5-efc3-7192-8cba-4c845fdc658d.webp",
    "width": 272,
    "height": 75
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d7b0-77ac-b9de-9a426bb42aa9.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019d54f5-d7b0-77ac-b9de-9a426bb42aa9",
    "storage_key": "property/6767906449167335/019d54f5-d7b0-77ac-b9de-9a426bb42aa9.webp",
    "width": 272,
    "height": 75
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162258/019d54d9-0a7f-7644-86f7-60a98c66fa2f.webp",
  "property_company_logo_media": {
    "alt_text": "AXIA RESIDENTIAL BY ARC logo",
    "public_id": "019d54d9-0a7f-7644-86f7-60a98c66fa2f",
    "storage_key": "company/5767906449162258/019d54d9-0a7f-7644-86f7-60a98c66fa2f.webp",
    "width": 3072,
    "height": 1849
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162258/019d54d9-c530-7559-a71a-a1a4613d29fc.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "AXIA Residential by ARC logo",
    "public_id": "019d54d9-c530-7559-a71a-a1a4613d29fc",
    "storage_key": "company/5767906449162258/019d54d9-c530-7559-a71a-a1a4613d29fc.webp",
    "width": 125,
    "height": 75
  },
  "property_primary_color": "#242424",
  "property_secondary_color": "#373737",
  "property_font_color": "#464646",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 3",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "1155 - 1182",
  "property_sqft_min": "1155",
  "property_sqft_max": "1182",
  "property_price_range": "$1300 - $1958",
  "property_price_min": "1300",
  "property_price_max": "1958",
  "property_available_units": null,
  "property_facebook_url": "https://www.facebook.com/thegatesatsouthbend/",
  "property_instagram_url": "https://www.instagram.com/thegatesatsouthbend/",
  "property_twitter_url": "https://x.com/gatessouthbend",
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJvQpv6HqpiIgRcRAJbBYXcUw",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/the-gates-at-south-bend-tuscaloosa",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Gates at South Bend",
  "property_home_romance_title": "Experience the Charm of Your New Apartment Home Today",
  "property_home_amenities_blurb": "Welcome to The Gates at South Bend, where comfort meets convenience in beautiful Tuscaloosa, AL. Choose from thoughtfully designed two and three-bedroom apartments featuring modern amenities like private balconies, and stylish wood-style flooring. Enjoy our lush grounds, playground, and dedicated on-site service team for the ultimate living experience.",
  "property_home_floorplans_blurb": "Welcome to The Gates at South Bend in charming Tuscaloosa, AL, where two and three-bedroom apartments blend modern comfort with stylish living. Experience spacious designs and vibrant community amenities. Browse our available homes to find the perfect floor plan that suits your lifestyle and transforms your way of living today!",
  "property_home_gallery_blurb": "Welcome to The Gates at South Bend, where spacious two and three-bedroom apartments blend modern comfort with community charm. Picture yourself enjoying our well-maintained grounds, relaxing by the picnic area, or unwinding on your private balcony. Embrace a lifestyle of convenience with a dedicated on-site service team—your perfect home awaits!",
  "property_home_neighborhood_blurb": "At The Gates at South Bend, comfort meets convenience in Tuscaloosa, AL. Nestled near premier educational institutions like The University of Alabama and Shelton State Community College, you'll thrive in a vibrant neighborhood. Enjoy outdoor spaces like Bowers Park and the Tuscaloosa River Walk, all just steps from your new home.",
  "property_home_reviews_blurb": "At The Gates at South Bend in Tuscaloosa, AL, residents embrace a vibrant lifestyle, raving about their “spacious apartments and friendly staff.” This welcoming community is designed for comfort and connection. Curious about life here? See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "Nestled in the heart of Tuscaloosa, The Gates at South Bend offers a vibrant community surrounded by local gems. Enjoy weekend adventures at the Alabama Museum of Natural History and unwind at the scenic Tuscaloosa River Walk. With welcoming parks and top educational institutions nearby, discover a lifestyle rich in opportunity.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to The Gates at South Bend in Tuscaloosa, AL, where modern living meets community charm. Choose from spacious two and three-bedroom apartments featuring stylish wood-style flooring, private balconies, and convenient in-unit washers and dryers. Delight in our picnic area, playground, and well-maintained grounds for an ideal lifestyle.",
  "property_applynow_blurb": "Welcome to The Gates at South Bend in Tuscaloosa, AL, where your ideal lifestyle awaits! Choose from spacious two or three-bedroom floor plans, each featuring modern amenities like in-home laundry, and stylish wood-style flooring. Enjoy community perks like a playground, picnic area, and professional on-site management. Lease online today!",
  "property_contactus_blurb": "At The Gates at South Bend in Tuscaloosa, AL, our thoughtfully designed two and three-bedroom floor plans offer the perfect blend of comfort and style. Ready to find your ideal home? Reach out to our leasing team today with any questions—your new adventure is just a message away!",
  "property_faqs_blurb": "At The Gates at South Bend in Tuscaloosa, AL, our diverse floor plans cater to every lifestyle with spacious two and three-bedroom layouts. Curious about our vibrant community? Visit our FAQs page, where answers to your questions await, offering insights into life in our welcoming neighborhood.",
  "property_floorplans_blurb": "At The Gates at South Bend in Tuscaloosa, AL, choose from spacious two and three-bedroom layouts designed for modern living. With thoughtfully crafted floor plans, each home balances comfort and style. Uncover the ideal space for your lifestyle—browse our available apartment homes today and envision your next chapter!",
  "property_gallery_blurb": "At The Gates at South Bend in Tuscaloosa, AL, our thoughtfully designed two and three-bedroom floor plans offer comfort and style. Picture yourself enjoying premium amenities, lush picnic areas, and a welcoming playground—perfect for making memories. Schedule your model home visit today!",
  "property_interactivemap_blurb": "Nestled in the heart of Tuscaloosa, The Gates at South Bend offers stylish two and three-bedroom apartments with modern amenities, including an inviting picnic area. Experience the perfect blend of comfort and convenience—explore our interactive community map to find your ideal home today!",
  "property_pets_blurb": "At The Gates at South Bend, we recognize your pets as cherished members of the family. Our pet-friendly apartment community comfortably accommodates up to two companions, ensuring your furry family members can also enjoy the comfort and warmth of your home. For more details about our pet policy or specific pet-related needs, please reach out to our dedicated on-site leasing team.",
  "property_referafriend_blurb": "At The Gates at South Bend in Tuscaloosa, AL, your perfect home awaits! With spacious two and three-bedroom floor plans, comfort and style come together. Elevate your living experience—refer a friend today and enjoy the joy of great neighbors in a vibrant community. Share the love of home!",
  "property_residentaccess_blurb": "At The Gates at South Bend in Tuscaloosa, AL, our spacious two and three-bedroom floor plans await to elevate your living experience. Conveniently manage your residency by logging into your resident portal—easy rent payments, maintenance requests, and more are just a click away! Join us today and embrace exceptional living.",
  "property_reviews_blurb": "At The Gates at South Bend in Tuscaloosa, residents rave about their experience, saying, “The staff is always friendly, and the community feels like home.” Dive into our reviews to see why our residents love living here. Your next adventure starts at The Gates! Read their thoughts now!",
  "property_created_at": "1775246839658",
  "property_scheduletour_blurb": "At The Gates at South Bend in Tuscaloosa, AL, our spacious two and three-bedroom floor plans offer the perfect blend of comfort and style. Schedule a tour today and see firsthand why our community feels like home. Curious about resident life? Their testimonials will leave you inspired!",
  "property_thankyou_blurb": "Thank you for reaching out to The Gates at South Bend in vibrant Tuscaloosa, AL! Our inviting two- and three-bedroom floor plans await your personal touch. Stay tuned—our team will be in contact soon to guide you toward your new home sweet home!",
  "property_virtualtours_blurb": "At The Gates at South Bend in Tuscaloosa, AL, your perfect home awaits! Our spacious two and three-bedroom floor plans are designed with your comfort in mind. Immerse yourself in our community by taking a virtual tour to see all that awaits you! Your new lifestyle starts here!",
  "property_copyright": "2026 All Rights Reserved. The Gates at South Bend",
  "property_seo_title_home": "The Gates at South Bend |  Apartments in Tuscaloosa, AL",
  "property_seo_description_home": "Experience upscale living at The Gates at South Bend, Tuscaloosa, AL. Choose from spacious 2-3 bedroom plans with premium amenities.",
  "property_seo_title_floorplans": "Floor Plans | Tuscaloosa, AL Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at The Gates at South Bend in Tuscaloosa, AL! Choose from spacious two- and three-bedroom floor plans tailored for your lifestyle.",
  "property_seo_title_amenities": "Amenities | Tuscaloosa, AL Apartments for Rent",
  "property_seo_description_amenities": "Discover comfort and convenience at The Gates at South Bend, Tuscaloosa. Enjoy spacious floor plans, a pool, and peaceful picnic spots!",
  "property_seo_title_gallery": "Gallery | Apartments in Tuscaloosa, AL",
  "property_seo_description_gallery": "Picture your life at The Gates at South Bend in Tuscaloosa, AL! Enjoy spacious two & three-bedroom homes, stunning amenities, and serene surroundings.",
  "property_seo_title_virtualtours": "Virtual Tours | The Gates at South Bend Apartments",
  "property_seo_description_virtualtours": "Experience The Gates at South Bend in Tuscaloosa, AL! Take a virtual tour of our spacious two and three-bedroom apartments – your next home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | The Gates at South Bend Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at The Gates at South Bend in Tuscaloosa! Enjoy spacious 2-3 bedroom layouts, premium amenities, and a vibrant community vibe.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Tuscaloosa, AL",
  "property_seo_description_neighborhood": "Live life to the fullest at The Gates at South Bend! Dive into Tuscaloosa's vibrant neighborhood and uncover local gems right outside your door.",
  "property_seo_title_contact": "Contact Us | The Gates at South Bend",
  "property_seo_description_contact": "Explore spacious two- and three-bedroom plans at The Gates at South Bend, Tuscaloosa, AL! Questions? Our leasing team is ready to assist!",
  "property_seo_title_faqs": "FAQs | Apartments in Tuscaloosa, AL",
  "property_seo_description_faqs": "Get insights on The Gates at South Bend! From floor plans to amenities, our FAQ page has all the answers about life in Tuscaloosa's premier community.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Tuscaloosa, AL",
  "property_seo_description_reviews": "Experience comfort at The Gates at South Bend in Tuscaloosa, AL. Read resident reviews and see why our two and three-bedroom apartments feel like home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Tuscaloosa, AL",
  "property_seo_description_applynow": "Elevate your lifestyle at The Gates at South Bend in Tuscaloosa. Choose from spacious 2- and 3-bedroom homes with amenities to enjoy—your new home awaits!",
  "property_seo_title_residentaccess": "Resident Access | The Gates at South Bend",
  "property_seo_description_residentaccess": "Experience convenience at The Gates at South Bend! Log in to your resident portal for easy rent payments, maintenance requests, and updates!",
  "property_seo_title_referafriend": "Refer A Friend | The Gates at South Bend",
  "property_seo_description_referafriend": "Refer a friend to The Gates at South Bend in Tuscaloosa, AL! Great friends make great neighbors—share the joy of community living today!",
  "property_seo_title_scheduletour": "Schedule a Tour | The Gates at South Bend",
  "property_seo_description_scheduletour": "Experience modern living at The Gates at South Bend in Tuscaloosa, AL. Secure your spot and schedule a tour of our vibrant community today!",
  "property_seo_title_privacy": "Privacy Policy | The Gates at South Bend",
  "property_seo_description_privacy": "Protect your personal information at The Gates at South Bend. Review our privacy policy to learn how we ensure your data remains secure in Tuscaloosa, AL.",
  "property_seo_title_accessibility": "Website Accessibility | The Gates at South Bend",
  "property_seo_description_accessibility": "Experience digital inclusion at The Gates at South Bend. Our commitment ensures everyone can easily navigate our community in vibrant Tuscaloosa, AL.",
  "property_seo_title_sitemap": "Sitemap | The Gates at South Bend",
  "property_seo_description_sitemap": "Uncover the layout of The Gates at South Bend in Tuscaloosa, AL. Navigate through our offerings and find your perfect apartment today!",
  "property_seo_title_thankyou": "Thank You | The Gates at South Bend",
  "property_seo_description_thankyou": "Thank you for reaching out! A team member from The Gates at South Bend in Tuscaloosa will connect soon to help you start your journey to your new home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Tuscaloosa, AL",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1790793466802",
  "amenities": [
    {
      "id": "custom_ebaa665e-77f6-4ed0-a9e2-1a0a4167b42b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "external_id": "P000000020",
      "title": "Model Home to View",
      "amount": "0.0000",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6bd61ea4-8ecc-4f8e-b817-a00b9c4a594d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "external_id": "P000000548",
      "title": "Access Gates",
      "amount": "0.0000",
      "description": "Access gate",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ff793e51-669a-42e2-8670-03b838a26cf9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "external_id": "P000000553",
      "title": "Well Maintained Grounds",
      "amount": "0.0000",
      "description": "Well Maintained Grounds",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_799b7559-8d19-4552-8a0f-9ebd33f4e8dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "external_id": "P000000596",
      "title": "Picnic Area",
      "amount": "0.0000",
      "description": "Picnic Area (firepits, benches)",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_17f4ea3e-4d1d-49e7-9861-473c06e60821",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "external_id": "S100000035",
      "title": "Playground Area",
      "amount": "0.0000",
      "description": "Playground Area",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_76fcd6cd-fe42-4fe6-9bb9-0cc09fbd53a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "external_id": "P000000003",
      "title": "1st Floor",
      "amount": "15.0000",
      "description": "1st Floor",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8283a881-d674-4c61-88d3-5ee247cbd879",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "external_id": "P000000006",
      "title": "Amenity Location Premium",
      "amount": "15.0000",
      "description": "Amenity Location Premium",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c59fcff7-d772-41f0-960f-df1d7ee05a45",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "external_id": "P000000560",
      "title": "Upgraded Flooring In All Downstairs Units",
      "amount": "0.0000",
      "description": "Upgraded Flooring In All Downstairs Units",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2920a3f1-d848-44a2-a454-3fd626ad479e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "external_id": "P000000563",
      "title": "Downstairs",
      "amount": "50.0000",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_55af916c-3248-4dd0-ba84-cffa7f248260",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "external_id": "P000000564",
      "title": "Balcony",
      "amount": "25.0000",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1793755c-87ba-4cfc-8674-d042f6715878",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "external_id": "P000000566",
      "title": "Furnished",
      "amount": "400.0000",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cc1ce696-b756-4692-8a14-3b9d2386a994",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "external_id": "P000000614",
      "title": "Floor 1",
      "amount": "0.0000",
      "description": "Floor 1",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c3002e8e-ebc3-49aa-97f4-4ca85c1363bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "external_id": "P000000748",
      "title": "Floor 2",
      "amount": "0.0000",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b4ab4120-6fab-4fe5-bf07-a87f11ea4a6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "external_id": "P000000750",
      "title": "Wood-Style Flooring",
      "amount": "0.0000",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_73ec3114-3536-4c39-8cd9-9a87878979af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "external_id": "P000000752",
      "title": "Washer and Dryer Provided",
      "amount": "50.0000",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f77a2be4-d784-444a-87e2-b4b8c060cadb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "external_id": "false",
      "title": "Carpet In Bedrooms Only",
      "amount": "false",
      "description": "Carpet In Bedrooms Only",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f0b0183e-d647-4c76-9b07-f53510ff775d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious 2 & 3 Bedrooms",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_18cc9260-d74f-4517-95be-7c1bc341ff03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "external_id": "false",
      "title": "Upgraded Flooring In Select Homes",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e5b3eb14-7e17-4226-a038-b56707438aa7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "external_id": "false",
      "title": "Private Balconies",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e648164c-6182-40ff-9f17-228e181cb9ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "external_id": "false",
      "title": "In-Home Washer and Dryer",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f8c54ad1-d318-447b-b9f9-7cfc236dd4c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Responsive Team",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9a18ea70-1a06-4c79-83a4-7bfefc6dd95a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Activity Spaces",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_86be3984-ef6c-43da-8cf1-bad22430751b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019e02de-4f49-71c9-8958-e2441117a930.webp",
      "image_media": {
        "alt_text": "Exterior view of a multifamily building with two entrances and manicured landscaping at The Gates at South Bend in Tuscaloosa, AL.",
        "public_id": "019e02de-4f49-71c9-8958-e2441117a930",
        "storage_key": "property/6767906449167335/019e02de-4f49-71c9-8958-e2441117a930.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "A charming exterior view showcasing the building's facade, including its entrances and well-maintained landscaping.",
      "link": "",
      "alt_text": "Exterior view of a multifamily building with two entrances and manicured landscaping at The Gates at South Bend in Tuscaloosa, AL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f939dd48-2c7b-4ad5-8338-97026f187caf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019e02dd-8e1f-76aa-9da9-2f88e5b4c3ed.webp",
      "image_media": {
        "alt_text": "Aerial view of a suburban neighborhood with apartment buildings and houses at The Gates at South Bend in Tuscaloosa, AL.",
        "public_id": "019e02dd-8e1f-76aa-9da9-2f88e5b4c3ed",
        "storage_key": "property/6767906449167335/019e02dd-8e1f-76aa-9da9-2f88e5b4c3ed.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "An aerial view of a suburban neighborhood featuring apartment buildings and single-family homes, showcasing the community's layout and surrounding environment.",
      "link": "",
      "alt_text": "Aerial view of a suburban neighborhood with apartment buildings and houses at The Gates at South Bend in Tuscaloosa, AL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_94da2cc5-e909-43a9-9ba5-9e68e9cfc53a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019e02dd-6872-76bf-8658-64e5e7b3aeff.webp",
      "image_media": {
        "alt_text": "Aerial view of a suburban neighborhood with apartment buildings and single-family homes at The Gates at South Bend in Tuscaloosa, AL.",
        "public_id": "019e02dd-6872-76bf-8658-64e5e7b3aeff",
        "storage_key": "property/6767906449167335/019e02dd-6872-76bf-8658-64e5e7b3aeff.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "An aerial perspective showcasing a diverse neighborhood featuring apartment complexes alongside charming single-family residences, offering a glimpse into the community's layout and surrounding landscape.",
      "link": "",
      "alt_text": "Aerial view of a suburban neighborhood with apartment buildings and single-family homes at The Gates at South Bend in Tuscaloosa, AL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5f54ae92-0e05-4f31-aebe-7264c9457499",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019e02dd-387c-722e-a7a5-14d2ab9c1623.webp",
      "image_media": {
        "alt_text": "The Gates at South Bend apartment complex exterior with townhome-style buildings and manicured landscaping at The Gates at South Bend in Tuscaloosa, AL.",
        "public_id": "019e02dd-387c-722e-a7a5-14d2ab9c1623",
        "storage_key": "property/6767906449167335/019e02dd-387c-722e-a7a5-14d2ab9c1623.webp",
        "width": 3072,
        "height": 2374
      },
      "title": "Community",
      "description": "Discover modern living at The Gates at South Bend, featuring attractive townhome-style architecture and lush green spaces.",
      "link": "",
      "alt_text": "The Gates at South Bend apartment complex exterior with townhome-style buildings and manicured landscaping at The Gates at South Bend in Tuscaloosa, AL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a7eca17f-219a-42b7-a443-321656e4502d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019e02dd-4ac9-742f-8cad-767dd2173cf3.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings and a school campus with a baseball field at The Gates at South Bend in Tuscaloosa, AL.",
        "public_id": "019e02dd-4ac9-742f-8cad-767dd2173cf3",
        "storage_key": "property/6767906449167335/019e02dd-4ac9-742f-8cad-767dd2173cf3.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "An aerial perspective showcasing the apartment complex adjacent to a school and athletic fields, offering a glimpse of the community's surroundings.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings and a school campus with a baseball field at The Gates at South Bend in Tuscaloosa, AL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e882202b-fe86-440c-9f34-31608339445d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019e02dd-4027-70d4-8e8f-252b43231142.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily property's building and surrounding landscape at The Gates at South Bend in Tuscaloosa, AL.",
        "public_id": "019e02dd-4027-70d4-8e8f-252b43231142",
        "storage_key": "property/6767906449167335/019e02dd-4027-70d4-8e8f-252b43231142.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "An aerial view showcases the architectural design of a multifamily property, highlighting its roof structure and integration with the surrounding urban environment.",
      "link": "",
      "alt_text": "Aerial view of a multifamily property's building and surrounding landscape at The Gates at South Bend in Tuscaloosa, AL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a816153a-f09f-4341-b215-99555d42d938",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019e02da-46af-737b-9204-5740a0f98a73.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with neat landscaping and a walkway at The Gates at South Bend in Tuscaloosa, AL.",
        "public_id": "019e02da-46af-737b-9204-5740a0f98a73",
        "storage_key": "property/6767906449167335/019e02da-46af-737b-9204-5740a0f98a73.webp",
        "width": 2374,
        "height": 3072
      },
      "title": "Community",
      "description": "Step into comfort and style at our community, featuring well-maintained exteriors and beautiful landscaping for a welcoming atmosphere.",
      "link": "",
      "alt_text": "Exterior of apartment buildings with neat landscaping and a walkway at The Gates at South Bend in Tuscaloosa, AL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3f1a79bd-03de-486e-84b9-21947183f048",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019e02da-4423-7735-951c-ab6e15509920.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with gray siding and white brick accents, featuring dark doors and manicured landscaping at The Gates at South Bend in Tuscaloosa, AL.",
        "public_id": "019e02da-4423-7735-951c-ab6e15509920",
        "storage_key": "property/6767906449167335/019e02da-4423-7735-951c-ab6e15509920.webp",
        "width": 2374,
        "height": 3072
      },
      "title": "Community",
      "description": "Charming apartment exteriors with a blend of gray siding and classic white brick, complemented by well-maintained landscaping. Your new home awaits!",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with gray siding and white brick accents, featuring dark doors and manicured landscaping at The Gates at South Bend in Tuscaloosa, AL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9458ca1e-68c2-458e-b6e9-4c37f2485200",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019e02da-4627-773a-b757-df9c3abf508b.webp",
      "image_media": {
        "alt_text": "Exterior view of townhome apartments with grey siding and dark grey brick on a sunny day at The Gates at South Bend in Tuscaloosa, AL.",
        "public_id": "019e02da-4627-773a-b757-df9c3abf508b",
        "storage_key": "property/6767906449167335/019e02da-4627-773a-b757-df9c3abf508b.webp",
        "width": 2374,
        "height": 3072
      },
      "title": "Community",
      "description": "Charming townhome apartments featuring a combination of dark grey brick and light grey siding, set amidst lush green lawns and mature trees under a clear blue sky.",
      "link": "",
      "alt_text": "Exterior view of townhome apartments with grey siding and dark grey brick on a sunny day at The Gates at South Bend in Tuscaloosa, AL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_926bda6d-d270-4bba-9537-1fc19ee7d861",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019e02d8-fdf0-764e-b4b8-1f651b7bf3d1.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with manicured bushes and trees at The Gates at South Bend in Tuscaloosa, AL.",
        "public_id": "019e02d8-fdf0-764e-b4b8-1f651b7bf3d1",
        "storage_key": "property/6767906449167335/019e02d8-fdf0-764e-b4b8-1f651b7bf3d1.webp",
        "width": 3072,
        "height": 2374
      },
      "title": "Community",
      "description": "Beautifully landscaped apartment buildings with charming entrances and well-maintained exteriors.",
      "link": "",
      "alt_text": "Exterior of apartment buildings with manicured bushes and trees at The Gates at South Bend in Tuscaloosa, AL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4c5b160a-48b7-41af-b22a-f29a752b54ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019e02dc-d395-748b-a85b-d599f87750c1.webp",
      "image_media": {
        "alt_text": "Living room with two gray sofas, a fireplace, and wall decor at The Gates at South Bend in Tuscaloosa, AL.",
        "public_id": "019e02dc-d395-748b-a85b-d599f87750c1",
        "storage_key": "property/6767906449167335/019e02dc-d395-748b-a85b-d599f87750c1.webp",
        "width": 3072,
        "height": 2374
      },
      "title": "Apartment",
      "description": "Cozy living room featuring two comfortable gray sofas, a modern electric fireplace, and tasteful wall decorations. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Living room with two gray sofas, a fireplace, and wall decor at The Gates at South Bend in Tuscaloosa, AL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c6119fa3-f51f-434e-b384-9aa6873e296e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019e02db-c62d-7544-a318-c377251735af.webp",
      "image_media": {
        "alt_text": "Staircase with dark wood steps and black railing at The Gates at South Bend in Tuscaloosa, AL.",
        "public_id": "019e02db-c62d-7544-a318-c377251735af",
        "storage_key": "property/6767906449167335/019e02db-c62d-7544-a318-c377251735af.webp",
        "width": 2374,
        "height": 3072
      },
      "title": "Apartment",
      "description": "Staircase with dark wood steps and a black railing, leading to an upper level. Features carpet and wood-look flooring.",
      "link": "",
      "alt_text": "Staircase with dark wood steps and black railing at The Gates at South Bend in Tuscaloosa, AL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_72894cc0-8b0d-4407-a12f-b138e7e24f9c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019e02db-ccc5-7268-8a90-79b24774e416.webp",
      "image_media": {
        "alt_text": "Interior view of a living room with stairs and a window at The Gates at South Bend in Tuscaloosa, AL.",
        "public_id": "019e02db-ccc5-7268-8a90-79b24774e416",
        "storage_key": "property/6767906449167335/019e02db-ccc5-7268-8a90-79b24774e416.webp",
        "width": 3072,
        "height": 2374
      },
      "title": "Apartment",
      "description": "Spacious living area with plush carpeting, stairs leading to the upper level, and a large window allowing natural light.",
      "link": "",
      "alt_text": "Interior view of a living room with stairs and a window at The Gates at South Bend in Tuscaloosa, AL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_359b96b8-b955-411f-8038-ce87b493c938",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019e02db-b19b-75e8-89c5-43d5605bb76c.webp",
      "image_media": {
        "alt_text": "Empty living room with stairs leading upstairs at The Gates at South Bend in Tuscaloosa, AL.",
        "public_id": "019e02db-b19b-75e8-89c5-43d5605bb76c",
        "storage_key": "property/6767906449167335/019e02db-b19b-75e8-89c5-43d5605bb76c.webp",
        "width": 3072,
        "height": 2374
      },
      "title": "Apartment",
      "description": "Spacious living area featuring plush carpeting and a staircase providing access to the upper level.",
      "link": "",
      "alt_text": "Empty living room with stairs leading upstairs at The Gates at South Bend in Tuscaloosa, AL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dd8461c4-b51d-46aa-a312-ab26b053cfc7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019e02db-8731-727e-82bc-a3cc88def5a6.webp",
      "image_media": {
        "alt_text": "Bedroom with a wooden bed, red and white bedding, and two Alabama Crimson Tide pillows at The Gates at South Bend in Tuscaloosa, AL.",
        "public_id": "019e02db-8731-727e-82bc-a3cc88def5a6",
        "storage_key": "property/6767906449167335/019e02db-8731-727e-82bc-a3cc88def5a6.webp",
        "width": 3072,
        "height": 2374
      },
      "title": "Apartment",
      "description": "Comfortable bedroom featuring a queen-size bed with plush bedding and decorative pillows. Includes a dresser and a spacious closet.",
      "link": "",
      "alt_text": "Bedroom with a wooden bed, red and white bedding, and two Alabama Crimson Tide pillows at The Gates at South Bend in Tuscaloosa, AL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_850fb88e-3052-4820-95c1-be7e0ac28507",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019e02db-862d-7759-9b28-bb1c0ce5a7c4.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed and Alabama Crimson Tide themed bedding at The Gates at South Bend in Tuscaloosa, AL.",
        "public_id": "019e02db-862d-7759-9b28-bb1c0ce5a7c4",
        "storage_key": "property/6767906449167335/019e02db-862d-7759-9b28-bb1c0ce5a7c4.webp",
        "width": 3072,
        "height": 2374
      },
      "title": "Apartment",
      "description": "A cozy bedroom featuring a queen-size bed with comfortable grey linens and accent pillows, perfect for a relaxing night's sleep.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed and Alabama Crimson Tide themed bedding at The Gates at South Bend in Tuscaloosa, AL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_92a36cd1-1825-45c6-a59b-6267094f13be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019e02db-8756-7663-a031-90e3c53d72e6.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel sink, and black refrigerator at The Gates at South Bend in Tuscaloosa, AL.",
        "public_id": "019e02db-8756-7663-a031-90e3c53d72e6",
        "storage_key": "property/6767906449167335/019e02db-8756-7663-a031-90e3c53d72e6.webp",
        "width": 2374,
        "height": 3072
      },
      "title": "Apartment",
      "description": "Explore this beautifully appointed kitchen featuring dark wood cabinetry, a deep stainless steel sink, and modern appliances, perfect for your culinary adventures.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel sink, and black refrigerator at The Gates at South Bend in Tuscaloosa, AL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a2c20008-5469-417b-b1bd-7208a9201da4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019e02da-b0a5-765e-b132-c92e8eec7d41.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and microwave at The Gates at South Bend in Tuscaloosa, AL.",
        "public_id": "019e02da-b0a5-765e-b132-c92e8eec7d41",
        "storage_key": "property/6767906449167335/019e02da-b0a5-765e-b132-c92e8eec7d41.webp",
        "width": 3072,
        "height": 2374
      },
      "title": "Apartment",
      "description": "Stylish kitchen featuring dark wood cabinetry, elegant granite countertops, and a full suite of modern appliances, including a microwave and stovetop.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and microwave at The Gates at South Bend in Tuscaloosa, AL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e78e735d-a40a-46c9-b8ba-fa5a1229231b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019e02da-9b03-70ac-b7d3-9659b9541993.webp",
      "image_media": {
        "alt_text": "Spacious living room with a green sofa, ottomans, and a side table at The Gates at South Bend in Tuscaloosa, AL.",
        "public_id": "019e02da-9b03-70ac-b7d3-9659b9541993",
        "storage_key": "property/6767906449167335/019e02da-9b03-70ac-b7d3-9659b9541993.webp",
        "width": 3072,
        "height": 2374
      },
      "title": "Apartment",
      "description": "Enjoy comfort and style in this beautifully appointed living room, featuring a plush green sofa, convenient ottomans, and elegant decor.",
      "link": "",
      "alt_text": "Spacious living room with a green sofa, ottomans, and a side table at The Gates at South Bend in Tuscaloosa, AL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fd7282d4-f502-4672-ad5d-72ac4e6659ae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019e02da-93e0-73af-a449-aed09fe59c3f.webp",
      "image_media": {
        "alt_text": "Spacious living room with a green sofa, ottoman, and dining area at The Gates at South Bend in Tuscaloosa, AL.",
        "public_id": "019e02da-93e0-73af-a449-aed09fe59c3f",
        "storage_key": "property/6767906449167335/019e02da-93e0-73af-a449-aed09fe59c3f.webp",
        "width": 3072,
        "height": 2374
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this inviting apartment living room, featuring a cozy sofa, ample space, and a dedicated dining area.",
      "link": "",
      "alt_text": "Spacious living room with a green sofa, ottoman, and dining area at The Gates at South Bend in Tuscaloosa, AL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b32a5bb4-d0c6-44e8-a3e7-1d0a5af59332",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019f7ffb-86a1-72ba-8bd4-fdb71599f803.webp",
      "image_media": {
        "alt_text": "Living room with sliding glass doors overlooking a courtyard.",
        "public_id": "019f7ffb-86a1-72ba-8bd4-fdb71599f803",
        "storage_key": "property/6767906449167335/019f7ffb-86a1-72ba-8bd4-fdb71599f803.webp",
        "width": 1448,
        "height": 1086
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sofa, armchair, and large windows with serene courtyard views.",
      "link": "",
      "alt_text": "Living room with sliding glass doors overlooking a courtyard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_81fb265f-e919-4ae1-ac62-d411096186c7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019f7ffb-8692-702e-afd5-964b375fab7f.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white vanity, black hardware, large mirror, toilet, and a woven rug.",
        "public_id": "019f7ffb-8692-702e-afd5-964b375fab7f",
        "storage_key": "property/6767906449167335/019f7ffb-8692-702e-afd5-964b375fab7f.webp",
        "width": 1086,
        "height": 1448
      },
      "title": "Apartment",
      "description": "Step into this stylish bathroom featuring a sleek white vanity with ample storage, a large black-framed mirror, and a comfortable woven rug. The modern design offers a clean and inviting space.",
      "link": "",
      "alt_text": "Modern bathroom with a white vanity, black hardware, large mirror, toilet, and a woven rug.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7c3f82a1-c104-4ead-bbfc-63208d6b74eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019f7ffb-8701-7473-8a37-f6481c0cbfc8.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, dark countertops, and a black faucet.",
        "public_id": "019f7ffb-8701-7473-8a37-f6481c0cbfc8",
        "storage_key": "property/6767906449167335/019f7ffb-8701-7473-8a37-f6481c0cbfc8.webp",
        "width": 1448,
        "height": 1086
      },
      "title": "Apartment",
      "description": "A clean and modern kitchen featuring white shaker cabinets, sleek dark countertops, and a stylish black faucet, perfect for any home.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, dark countertops, and a black faucet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e0e24601-e69b-485a-9161-6efbcaabe018",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019f7ffb-86e8-779b-819c-07827a226450.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a breakfast bar.",
        "public_id": "019f7ffb-86e8-779b-819c-07827a226450",
        "storage_key": "property/6767906449167335/019f7ffb-86e8-779b-819c-07827a226450.webp",
        "width": 1448,
        "height": 1086
      },
      "title": "Apartment",
      "description": "Step into this beautifully designed kitchen, featuring sleek stainless steel appliances, ample white cabinetry, and a stylish breakfast bar for convenient dining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a breakfast bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e33f47a6-84a7-45a6-8747-c6a354959117",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019f7ffb-8695-75ed-af55-612be3afa99c.webp",
      "image_media": {
        "alt_text": "Primary bedroom with a king-sized bed, large window, and ceiling fan.",
        "public_id": "019f7ffb-8695-75ed-af55-612be3afa99c",
        "storage_key": "property/6767906449167335/019f7ffb-8695-75ed-af55-612be3afa99c.webp",
        "width": 1448,
        "height": 1086
      },
      "title": "Apartment",
      "description": "Spacious primary bedroom featuring a king-sized bed, plush bedding, and ample natural light from a large window. This inviting space includes a ceiling fan and elegant decor.",
      "link": "",
      "alt_text": "Primary bedroom with a king-sized bed, large window, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9e463a36-ec59-422d-8763-dce04b625651",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019e02dd-35d2-72ad-ba5b-4fc52c4285cb.webp",
      "image_media": {
        "alt_text": "Mailboxes in front of apartment buildings.",
        "public_id": "019e02dd-35d2-72ad-ba5b-4fc52c4285cb",
        "storage_key": "property/6767906449167335/019e02dd-35d2-72ad-ba5b-4fc52c4285cb.webp",
        "width": 3072,
        "height": 2374
      },
      "title": "Community",
      "description": "Row of mailboxes situated in front of apartment buildings with cars parked nearby.",
      "link": "",
      "alt_text": "Mailboxes in front of apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_202bf91a-e912-4fe4-99bd-d09811ab116a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019e02d8-2889-779b-8bd1-1891c2e38c39.webp",
      "image_media": {
        "alt_text": "The Gates at South Bend monument sign with landscaping.",
        "public_id": "019e02d8-2889-779b-8bd1-1891c2e38c39",
        "storage_key": "property/6767906449167335/019e02d8-2889-779b-8bd1-1891c2e38c39.webp",
        "width": 3072,
        "height": 2374
      },
      "title": "Community",
      "description": "Welcome to The Gates at South Bend, a beautiful community with attractive signage and well-maintained grounds.",
      "link": "",
      "alt_text": "The Gates at South Bend monument sign with landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_85a379b6-63dc-466e-a6f7-1e354ad3f1cd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d782a-303e-773a-af90-11acf6247337.webp",
      "image_media": {
        "alt_text": "Dining area with a round table and four chairs in a modern apartment.",
        "public_id": "019d782a-303e-773a-af90-11acf6247337",
        "storage_key": "property/6767906449167335/019d782a-303e-773a-af90-11acf6247337.webp",
        "width": 1000,
        "height": 667
      },
      "title": "Apartment",
      "description": "Gather around the dining table in this stylish apartment, perfect for meals and conversations. Includes a pass-through to the laundry area.",
      "link": "",
      "alt_text": "Dining area with a round table and four chairs in a modern apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_51b14581-6e55-448d-8445-ec96d49387d7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d782a-1d01-7767-bf3c-5b8002bae0a3.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with fire pit and built-in grill station",
        "public_id": "019d782a-1d01-7767-bf3c-5b8002bae0a3",
        "storage_key": "property/6767906449167335/019d782a-1d01-7767-bf3c-5b8002bae0a3.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Gather around the fire pit or enjoy an outdoor meal at the built-in grill station. This amenity space is perfect for entertaining.",
      "link": "",
      "alt_text": "Outdoor seating area with fire pit and built-in grill station",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2b78b8ac-c1ff-4187-bfb4-fc8f5da04a0d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d782a-20f4-7267-a3e6-124c7d133f4a.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, plush blankets, and modern decor.",
        "public_id": "019d782a-20f4-7267-a3e6-124c7d133f4a",
        "storage_key": "property/6767906449167335/019d782a-20f4-7267-a3e6-124c7d133f4a.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a queen-size bed, soft linens, and stylish decorative accents.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, plush blankets, and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_00ef1766-b146-4578-bc1d-82c194a11132",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d782a-1cd7-731b-b7ab-ba35a334c2fa.webp",
      "image_media": {
        "alt_text": "A modern living room with a deep green sofa and two orange accent chairs.",
        "public_id": "019d782a-1cd7-731b-b7ab-ba35a334c2fa",
        "storage_key": "property/6767906449167335/019d782a-1cd7-731b-b7ab-ba35a334c2fa.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Stylish and inviting living area featuring a plush green sofa, two vibrant orange armchairs, and a marble-top coffee table, perfect for relaxing.",
      "link": "",
      "alt_text": "A modern living room with a deep green sofa and two orange accent chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_698eee70-5cf2-437f-824f-e58a9687df21",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f7-c64f-7188-bf09-c4ca34fa91d7.webp",
      "image_media": {
        "alt_text": "A stylish bedroom featuring a comfortable daybed, a modern armchair, and a sleek desk with a chair.",
        "public_id": "019d54f7-c64f-7188-bf09-c4ca34fa91d7",
        "storage_key": "property/6767906449167335/019d54f7-c64f-7188-bf09-c4ca34fa91d7.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "This inviting bedroom offers a blend of comfort and style, perfect for relaxation or productivity. It features a daybed, an armchair, and a desk area.",
      "link": "",
      "alt_text": "A stylish bedroom featuring a comfortable daybed, a modern armchair, and a sleek desk with a chair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4f8f37ec-0b54-42a6-9349-2369df395bd0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f7-ba2c-77b8-8ec9-2583e4f0a6fd.webp",
      "image_media": {
        "alt_text": "Bathroom with double vanity, toilet, and shower/tub combo with striped shower curtain.",
        "public_id": "019d54f7-ba2c-77b8-8ec9-2583e4f0a6fd",
        "storage_key": "property/6767906449167335/019d54f7-ba2c-77b8-8ec9-2583e4f0a6fd.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a double vanity with white countertops and dark wood cabinets, a toilet, and a shower/tub combination with a decorative striped shower curtain.",
      "link": "",
      "alt_text": "Bathroom with double vanity, toilet, and shower/tub combo with striped shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3f38ad0a-b75e-4622-8394-283bc9de78ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d782a-1c65-723d-a83d-48d0260530ce.webp",
      "image_media": {
        "alt_text": "A plush queen-size bed with white linens and a pink throw is the centerpiece of this bedroom, flanked by a nightstand and a large potted plant.",
        "public_id": "019d782a-1c65-723d-a83d-48d0260530ce",
        "storage_key": "property/6767906449167335/019d782a-1c65-723d-a83d-48d0260530ce.webp",
        "width": 1000,
        "height": 667
      },
      "title": "Apartment",
      "description": "Cozy and inviting, this bedroom features a comfortable queen-size bed with soft white linens, accented by colorful throw pillows and a stylish headboard. The room is bright and airy, with blinds on the window and decorative artwork on the wall, creating a serene atmosphere.",
      "link": "",
      "alt_text": "A plush queen-size bed with white linens and a pink throw is the centerpiece of this bedroom, flanked by a nightstand and a large potted plant.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cf9a1284-26cd-43bf-bf43-7d2a4770b5bb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f8-25b3-77ed-ba80-d8851dab3496.webp",
      "image_media": {
        "alt_text": "Living room with a green sofa, two orange chairs, and a marble coffee table.",
        "public_id": "019d54f8-25b3-77ed-ba80-d8851dab3496",
        "storage_key": "property/6767906449167335/019d54f8-25b3-77ed-ba80-d8851dab3496.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a plush green sofa, two accent chairs, and a modern marble coffee table, perfect for relaxing.",
      "link": "",
      "alt_text": "Living room with a green sofa, two orange chairs, and a marble coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9c0ad762-d381-4517-8557-8116d7def818",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f7-9134-75d4-98e6-4587aed2f7cf.webp",
      "image_media": {
        "alt_text": "Dining area with a round table and four chairs, pass-through window to laundry area.",
        "public_id": "019d54f7-9134-75d4-98e6-4587aed2f7cf",
        "storage_key": "property/6767906449167335/019d54f7-9134-75d4-98e6-4587aed2f7cf.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Gather around the dining table in your new apartment, perfect for meals and entertaining. The open pass-through to the laundry area adds convenience.",
      "link": "",
      "alt_text": "Dining area with a round table and four chairs, pass-through window to laundry area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_20206292-17fc-4384-b305-ce8c70f7c6a0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f7-8fae-7033-8324-4bb93b294a34.webp",
      "image_media": {
        "alt_text": "Stylish living room with a green velvet couch, orange accent chairs, and modern decor.",
        "public_id": "019d54f7-8fae-7033-8324-4bb93b294a34",
        "storage_key": "property/6767906449167335/019d54f7-8fae-7033-8324-4bb93b294a34.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed living room, featuring plush seating and contemporary design elements.",
      "link": "",
      "alt_text": "Stylish living room with a green velvet couch, orange accent chairs, and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_e7d6a5f4-40f1-43bf-a0ff-68d2d256456c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "210 McCorvey Dr, Tuscaloosa, AL 35487, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-1daf-7619-8d2d-9b0121f2bc48.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of Raising Cane's Chicken Fingers restaurant with outdoor seating.",
        "public_id": "019d54f5-1daf-7619-8d2d-9b0121f2bc48",
        "storage_key": "property/6767906449167335/019d54f5-1daf-7619-8d2d-9b0121f2bc48.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/al/tuscaloosa/210-mc-corvey-drive",
      "poi_directions_map_url": "https://maps.google.com/?cid=14922713608828256196&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "33.2164102",
      "poi_longitude": "-87.5464087",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 205-348-8577",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d2dc-726a-b147-ca7771ffa195.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized icon of a fork and knife",
        "public_id": "019d54f5-d2dc-726a-b147-ca7771ffa195",
        "storage_key": "property/6767906449167335/019d54f5-d2dc-726a-b147-ca7771ffa195.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJE5puSqIChogRxH8Ym_YgGM8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_3661291f-eced-455c-aba2-ca6b148c6fba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "Big Bad Breakfast - Tuscaloosa",
      "poi_type": "Restaurants",
      "poi_address": "520 19th Ave, Tuscaloosa, AL 35401, USA",
      "poi_short_description": "Chain for breakfast staples such as custom-created meats, biscuits, waffles and local coffee served in a casual environment.",
      "poi_long_description": "People say this restaurant serves delicious biscuits, grits, and waffles. They highlight the fast service and friendly staff. They also like the great vibe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-2b6c-7097-b66c-4d95e52f423f.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior building facade with \"BIG BAD BREAKFAST\" signage.",
        "public_id": "019d54f5-2b6c-7097-b66c-4d95e52f423f",
        "storage_key": "property/6767906449167335/019d54f5-2b6c-7097-b66c-4d95e52f423f.webp",
        "width": 3072,
        "height": 1493
      },
      "poi_business_url": "https://bigbadbreakfast.com/locations/tuscaloosa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5268556775459025558&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "big-bad-breakfast---tuscaloosa",
      "poi_latitude": "33.2109537",
      "poi_longitude": "-87.5616203",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 205-539-6859",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d2dc-726a-b147-ca7771ffa195.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized icon of a fork and knife",
        "public_id": "019d54f5-d2dc-726a-b147-ca7771ffa195",
        "storage_key": "property/6767906449167335/019d54f5-d2dc-726a-b147-ca7771ffa195.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLXDwNUADhogRlnI2KHmsHUk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_ea6a0e0f-5f67-430f-bdd3-acc054ae81db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "Dreamland BBQ",
      "poi_type": "Restaurants",
      "poi_address": "5535 15th Ave E, Tuscaloosa, AL 35405, USA",
      "poi_short_description": "Local BBQ chain serving hickory-fired ribs, plates & sandwiches, plus wings & comfort sides.",
      "poi_long_description": "People say this barbecue restaurant serves delicious ribs, chicken, and sausage, and that the banana pudding is a must-try. They highlight the tender meat, flavorful sauce, and the generous portions. They also like the fast service and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-321d-7131-8776-85674f246a3f.webp",
      "poi_featured_image_media": {
        "alt_text": "Interior of a sports-themed bar with a long counter, bar stools, and tables.",
        "public_id": "019d54f5-321d-7131-8776-85674f246a3f",
        "storage_key": "property/6767906449167335/019d54f5-321d-7131-8776-85674f246a3f.webp",
        "width": 2932,
        "height": 1768
      },
      "poi_business_url": "https://dreamlandbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12995611696072638106&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dreamland-bbq",
      "poi_latitude": "33.1564994",
      "poi_longitude": "-87.5166685",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 205-758-8135",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d2dc-726a-b147-ca7771ffa195.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized icon of a fork and knife",
        "public_id": "019d54f5-d2dc-726a-b147-ca7771ffa195",
        "storage_key": "property/6767906449167335/019d54f5-d2dc-726a-b147-ca7771ffa195.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJC0kLbJKpiIgRmj5S3_uvWbQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_d9494c0e-9332-41b3-8f86-833828c8a99c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "2015 McFarland Blvd E, Tuscaloosa, AL 35404, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves delicious salads and grilled chicken. They also highlight the friendly and efficient service, and the clean atmosphere.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-1f35-775c-8dfe-3395ea990f49.webp",
      "poi_featured_image_media": {
        "alt_text": "Chick-fil-A restaurant building exterior with a white car parked in a handicapped spot.",
        "public_id": "019d54f5-1f35-775c-8dfe-3395ea990f49",
        "storage_key": "property/6767906449167335/019d54f5-1f35-775c-8dfe-3395ea990f49.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/al/tuscaloosa?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=9705522707728600658&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "33.19154690000001",
      "poi_longitude": "-87.5251344",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 205-752-9999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d2dc-726a-b147-ca7771ffa195.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized icon of a fork and knife",
        "public_id": "019d54f5-d2dc-726a-b147-ca7771ffa195",
        "storage_key": "property/6767906449167335/019d54f5-d2dc-726a-b147-ca7771ffa195.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPZ0sozOoiIgRUo6mCXvxsIY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_9aa26ad7-bc0b-4d55-9ff3-1860f50264ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "Baumhower's Victory Grille",
      "poi_type": "Restaurants",
      "poi_address": "500 Harper Lee Dr, Tuscaloosa, AL 35404, USA",
      "poi_short_description": "Enduring sports-themed chain with a menu of pub grub, steaks, seafood & other entrees, plus TVs.",
      "poi_long_description": "People say this restaurant serves delicious wings and burgers. They also highlight the friendly and attentive service, and the fun, lively atmosphere, especially on game days.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-1afd-7428-8b29-a1a135b503b6.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of Baumhower's Victory Grill restaurant with beige and brick facade.",
        "public_id": "019d54f5-1afd-7428-8b29-a1a135b503b6",
        "storage_key": "property/6767906449167335/019d54f5-1afd-7428-8b29-a1a135b503b6.webp",
        "width": 2845,
        "height": 1883
      },
      "poi_business_url": "https://baumhowers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1537092287408360936&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "baumhowers-victory-grille",
      "poi_latitude": "33.2128138",
      "poi_longitude": "-87.52387379999999",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 205-409-9922",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d2dc-726a-b147-ca7771ffa195.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized icon of a fork and knife",
        "public_id": "019d54f5-d2dc-726a-b147-ca7771ffa195",
        "storage_key": "property/6767906449167335/019d54f5-d2dc-726a-b147-ca7771ffa195.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEfiV7hWoiIgR6M33oUrZVBU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_86f365b1-a213-464d-882b-64a57211f597",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "Publix Super Market at University Town Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "1190 University Blvd, Tuscaloosa, AL 35401, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "People say this supermarket offers a wide selection of fresh produce, quality meats, and everyday essentials, as well as a deli and bakery with freshly prepared items. They also highlight the friendly and helpful staff, the clean and well-organized store, and the convenient parking.\n\nOther reviews mention the deli orders can be delayed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-1fb8-7699-aafb-aa76dc51dafb.webp",
      "poi_featured_image_media": {
        "alt_text": "Publix Super Market logo and entrance",
        "public_id": "019d54f5-1fb8-7699-aafb-aa76dc51dafb",
        "storage_key": "property/6767906449167335/019d54f5-1fb8-7699-aafb-aa76dc51dafb.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1083&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=3325504035414497612&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "publix-super-market-at-university-town-center",
      "poi_latitude": "33.2120857",
      "poi_longitude": "-87.5535233",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 205-247-5044",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d2b3-7242-959a-ad9c0dbadddf.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d54f5-d2b3-7242-959a-ad9c0dbadddf",
        "storage_key": "property/6767906449167335/019d54f5-d2b3-7242-959a-ad9c0dbadddf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwS9aGZYChogRTFkCCk2QJi4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_38ba74c7-097e-4ed6-8a18-5b2c33466b31",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "1601 13th Ave E, Tuscaloosa, AL 35404, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a wide selection of tools, building materials, appliances, and garden supplies. They also highlight the helpful and knowledgeable employees, and the well-organized, clean store.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-1d3b-7756-903f-4f44b940d6f0.webp",
      "poi_featured_image_media": {
        "alt_text": "The Home Depot store entrance with grills for sale outside.",
        "public_id": "019d54f5-1d3b-7756-903f-4f44b940d6f0",
        "storage_key": "property/6767906449167335/019d54f5-1d3b-7756-903f-4f44b940d6f0.webp",
        "width": 2448,
        "height": 2448
      },
      "poi_business_url": "https://www.homedepot.com/l/Tuscaloosa/AL/Tuscaloosa/35404/877?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=14993620150156637416&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "33.1955614",
      "poi_longitude": "-87.5178431",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 205-633-2038",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d2dd-72ed-b5f4-518ff38b13a9.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon with a smiling face.",
        "public_id": "019d54f5-d2dd-72ed-b5f4-518ff38b13a9",
        "storage_key": "property/6767906449167335/019d54f5-d2dd-72ed-b5f4-518ff38b13a9.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJd9pCykmoiIgR6LQ5QxYKFNA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_bb2afd93-4751-4b71-9176-a97ea493c4e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "University Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "1701 McFarland Blvd E, Tuscaloosa, AL 35404, USA",
      "poi_short_description": "Sizable, long-standing indoor shopping center with several department stores & occasional events.",
      "poi_long_description": "People say this shopping center offers a variety of stores and a central courtyard with fountains. They also highlight the nostalgic 80s vibe and the convenience of having shops and restaurants under one roof.\n\nSome reviews mention the stores can be empty.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-2c1b-70c2-a90b-8ee16f8bbaee.webp",
      "poi_featured_image_media": {
        "alt_text": "Interior view of a shopping mall with Victoria's Secret and Belk stores visible.",
        "public_id": "019d54f5-2c1b-70c2-a90b-8ee16f8bbaee",
        "storage_key": "property/6767906449167335/019d54f5-2c1b-70c2-a90b-8ee16f8bbaee.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.university-mall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7014732509235260257&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-mall",
      "poi_latitude": "33.1948058",
      "poi_longitude": "-87.5221224",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 205-553-8414",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d2dd-72ed-b5f4-518ff38b13a9.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon with a smiling face.",
        "public_id": "019d54f5-d2dd-72ed-b5f4-518ff38b13a9",
        "storage_key": "property/6767906449167335/019d54f5-d2dd-72ed-b5f4-518ff38b13a9.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJabsPJzSoiIgRYStaLw1WWWE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_0507c1c2-9f69-4930-befe-635565cf079e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "4201 Hargrove E Rd, Tuscaloosa, AL 35405, USA",
      "poi_short_description": "Grocery store with a deli and a pharmacy, plus check cashing and self-checkout.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-1c93-7140-9738-1cf0a9eb7a28.webp",
      "poi_featured_image_media": {
        "alt_text": "Walmart Neighborhood Market exterior",
        "public_id": "019d54f5-1c93-7140-9738-1cf0a9eb7a28",
        "storage_key": "property/6767906449167335/019d54f5-1c93-7140-9738-1cf0a9eb7a28.webp",
        "width": 1080,
        "height": 1920
      },
      "poi_business_url": "https://www.walmart.com/store/5256-tuscaloosa-al/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=1333643222388640348&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "33.1699615",
      "poi_longitude": "-87.482569",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 205-632-6205",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d2b3-7242-959a-ad9c0dbadddf.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d54f5-d2b3-7242-959a-ad9c0dbadddf",
        "storage_key": "property/6767906449167335/019d54f5-d2b3-7242-959a-ad9c0dbadddf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm3rdRBSpiIgRXAqV33ENghI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_20bbbb04-b10b-457b-a0d8-ef2a6af33ce0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "The University of Alabama",
      "poi_type": "Education",
      "poi_address": "Tuscaloosa, AL 35487, USA",
      "poi_short_description": "This 1831 research school with a leafy campus & historic buildings has a natural history museum.",
      "poi_long_description": "This 1831 research school with a leafy campus & historic buildings has a natural history museum.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-3bb5-7428-9ba9-eab1ad0b616e.webp",
      "poi_featured_image_media": {
        "alt_text": "Bryant-Denny Stadium entrance with University of Alabama signage.",
        "public_id": "019d54f5-3bb5-7428-9ba9-eab1ad0b616e",
        "storage_key": "property/6767906449167335/019d54f5-3bb5-7428-9ba9-eab1ad0b616e.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.ua.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16072829938233641234&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-university-of-alabama",
      "poi_latitude": "33.2114385",
      "poi_longitude": "-87.5401002",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 205-348-6010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d292-7639-9dd3-99f7d42003cf.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d54f5-d292-7639-9dd3-99f7d42003cf",
        "storage_key": "property/6767906449167335/019d54f5-d292-7639-9dd3-99f7d42003cf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJuyDejJkChogREgmu26spDt8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_fcc46cce-6604-43ed-8ab9-d04ce6276ede",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "Shelton State Community College",
      "poi_type": "Education",
      "poi_address": "9500 Old Greensboro Rd, Tuscaloosa, AL 35405, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-397f-71cb-8555-49b1c7d9f3fa.webp",
      "poi_featured_image_media": {
        "alt_text": "Interior of a large, modern atrium with a prominent staircase and seating areas.",
        "public_id": "019d54f5-397f-71cb-8555-49b1c7d9f3fa",
        "storage_key": "property/6767906449167335/019d54f5-397f-71cb-8555-49b1c7d9f3fa.webp",
        "width": 700,
        "height": 467
      },
      "poi_business_url": "http://www.sheltonstate.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15474038228804507705&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "shelton-state-community-college",
      "poi_latitude": "33.120633",
      "poi_longitude": "-87.561464",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 205-391-2211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d292-7639-9dd3-99f7d42003cf.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d54f5-d292-7639-9dd3-99f7d42003cf",
        "storage_key": "property/6767906449167335/019d54f5-d292-7639-9dd3-99f7d42003cf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJyzVEor0BhogRORi1vMjTvtY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_bb5b9083-0229-4944-99d6-928c13fe6156",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "Paul W. Bryant Museum",
      "poi_type": "Education",
      "poi_address": "300 Paul W Bryant Dr, Tuscaloosa, AL 35487, USA",
      "poi_short_description": "University of Alabama's museum for sports memorabilia, archives & exhibits featuring team stars.",
      "poi_long_description": "University of Alabama's museum for sports memorabilia, archives & exhibits featuring team stars.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-3b01-702c-a356-fe6d1c440770.webp",
      "poi_featured_image_media": {
        "alt_text": "Bust of Paul W. Bryant in front of the Paul W. Bryant Wall of Honor.",
        "public_id": "019d54f5-3b01-702c-a356-fe6d1c440770",
        "storage_key": "property/6767906449167335/019d54f5-3b01-702c-a356-fe6d1c440770.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://bryantmuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3504796092742993705&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "paul-w-bryant-museum",
      "poi_latitude": "33.2066414",
      "poi_longitude": "-87.5396499",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 205-348-4668",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d292-7639-9dd3-99f7d42003cf.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d54f5-d292-7639-9dd3-99f7d42003cf",
        "storage_key": "property/6767906449167335/019d54f5-d292-7639-9dd3-99f7d42003cf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJITPs-J0ChogRKYcfJnqJozA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_7271fa14-72f8-48f1-9916-b8931b442080",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "Stillman College",
      "poi_type": "Education",
      "poi_address": "3601 Stillman Blvd, Tuscaloosa, AL 35401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-477b-76cf-846d-23af94a4550c.webp",
      "poi_featured_image_media": {
        "alt_text": "Three students in beige cardigans and ties smiling and talking outdoors.",
        "public_id": "019d54f5-477b-76cf-846d-23af94a4550c",
        "storage_key": "property/6767906449167335/019d54f5-477b-76cf-846d-23af94a4550c.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "https://stillman.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14718762829808927418&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "stillman-college",
      "poi_latitude": "33.1982647",
      "poi_longitude": "-87.5859218",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 205-349-4240",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d292-7639-9dd3-99f7d42003cf.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d54f5-d292-7639-9dd3-99f7d42003cf",
        "storage_key": "property/6767906449167335/019d54f5-d292-7639-9dd3-99f7d42003cf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJD2ShOQQDhogRugL8c8-MQ8w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_785093aa-939c-4f35-97d3-bfe99e73e5ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "Bryant Conference Center",
      "poi_type": "Education",
      "poi_address": "240 Paul W Bryant Dr, Tuscaloosa, AL 35487, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-525e-75c1-9159-a685c9fe1b1f.webp",
      "poi_featured_image_media": {
        "alt_text": "Cheerleaders performing with batons on a stage in front of a large screen displaying letters and a performance.",
        "public_id": "019d54f5-525e-75c1-9159-a685c9fe1b1f",
        "storage_key": "property/6767906449167335/019d54f5-525e-75c1-9159-a685c9fe1b1f.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://bcc.ua.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=454547141495140350&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bryant-conference-center",
      "poi_latitude": "33.2062794",
      "poi_longitude": "-87.5388906",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 205-348-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d292-7639-9dd3-99f7d42003cf.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d54f5-d292-7639-9dd3-99f7d42003cf",
        "storage_key": "property/6767906449167335/019d54f5-d292-7639-9dd3-99f7d42003cf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJo87vTCeoiIgR_q98hjfgTgY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_6b26f0f3-ed6d-4a27-a71a-8f43ce63fb32",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "Bryant-Denny Stadium",
      "poi_type": "Entertainment",
      "poi_address": "920 Paul W Bryant Dr Gate 34, Tuscaloosa, AL 35487, USA",
      "poi_short_description": "College football stadium that's home to the University of Alabama's Crimson Tide.",
      "poi_long_description": "People say this stadium offers entertaining games and a fun atmosphere, especially during night games. They highlight the smooth security process, friendly staff, and convenient amenities, such as numerous bathrooms and concession stands. They also like the beautiful campus and the exciting marching band. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-5737-775d-867f-3f754c743863.webp",
      "poi_featured_image_media": {
        "alt_text": "View of a packed football stadium with fans cheering as teams take the field at sunset.",
        "public_id": "019d54f5-5737-775d-867f-3f754c743863",
        "storage_key": "property/6767906449167335/019d54f5-5737-775d-867f-3f754c743863.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.rolltide.com/sports/2016/6/10/facilities-bryant-denny-html.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=947704701053049182&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bryant-denny-stadium",
      "poi_latitude": "33.2076602",
      "poi_longitude": "-87.5504723",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 205-348-2262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d290-76e5-a359-a4cb0f28150f.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized illustration of two people sitting at a table.",
        "public_id": "019d54f5-d290-76e5-a359-a4cb0f28150f",
        "storage_key": "property/6767906449167335/019d54f5-d290-76e5-a359-a4cb0f28150f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ58gIQ5cChogRXhk8imfsJg0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_295fb495-ff41-4ee0-8665-ff1f901ad7df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "Sewell-Thomas Stadium",
      "poi_type": "Entertainment",
      "poi_address": "241 Paul W Bryant Dr, Tuscaloosa, AL 35487, USA",
      "poi_short_description": "Known as \"The Joe,\" the home of Alabama Crimson Tide baseball contains murals depicting its history.",
      "poi_long_description": "Known as \"The Joe,\" the home of Alabama Crimson Tide baseball contains murals depicting its history.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-57e4-7228-a2bd-41e2ade5a251.webp",
      "poi_featured_image_media": {
        "alt_text": "Baseball stadium with field, scoreboard showing 'ALABAMA WINS', and spectators in the stands.",
        "public_id": "019d54f5-57e4-7228-a2bd-41e2ade5a251",
        "storage_key": "property/6767906449167335/019d54f5-57e4-7228-a2bd-41e2ade5a251.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://rolltide.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15782332069150075884&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sewell-thomas-stadium",
      "poi_latitude": "33.2048713",
      "poi_longitude": "-87.53862099999999",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 205-348-2262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d290-76e5-a359-a4cb0f28150f.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized illustration of two people sitting at a table.",
        "public_id": "019d54f5-d290-76e5-a359-a4cb0f28150f",
        "storage_key": "property/6767906449167335/019d54f5-d290-76e5-a359-a4cb0f28150f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJc8n2fSeoiIgR7CvyBGYbBts",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_75621aec-404f-4f69-a463-842847956938",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "Alabama Museum of Natural History",
      "poi_type": "Entertainment",
      "poi_address": "427 6th Ave, Tuscaloosa, AL 35487, USA",
      "poi_short_description": "Local paleontology, archaeology, geology & natural science exhibits at the University of Alabama.",
      "poi_long_description": "People say this natural history museum offers a variety of interesting exhibits, including a beehive exhibit and a collection of fossils, minerals, and artifacts. They highlight the affordable admission fee and the small gift shop with unique items. They also like the informative and engaging experience.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-51fd-7499-a443-a6a2a9548b5e.webp",
      "poi_featured_image_media": {
        "alt_text": "Front exterior of Smith Hall with trees and banners.",
        "public_id": "019d54f5-51fd-7499-a443-a6a2a9548b5e",
        "storage_key": "property/6767906449167335/019d54f5-51fd-7499-a443-a6a2a9548b5e.webp",
        "width": 2048,
        "height": 1536
      },
      "poi_business_url": "https://almnh.museums.ua.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13761200969915647238&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "alabama-museum-of-natural-history",
      "poi_latitude": "33.2118707",
      "poi_longitude": "-87.54387849999999",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 205-348-7550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d291-702e-8bfe-54c36f35fc73.webp",
      "poi_map_icon_media": {
        "alt_text": "Logo featuring the letter M inside a building outline.",
        "public_id": "019d54f5-d291-702e-8bfe-54c36f35fc73",
        "storage_key": "property/6767906449167335/019d54f5-d291-702e-8bfe-54c36f35fc73.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJU7nueRCoiIgRBkWVRl-b-b4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_1ac25b38-7848-487d-8a16-bca3f142b7fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "Student Center Plaza",
      "poi_type": "Entertainment",
      "poi_address": "Crimson Promenade, Tuscaloosa, AL 35401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-5779-720d-8b3f-07c4bc2ff7e9.webp",
      "poi_featured_image_media": {
        "alt_text": "Wide plaza with a fountain in the center, benches, tables, umbrellas, lampposts, and trees.",
        "public_id": "019d54f5-5779-720d-8b3f-07c4bc2ff7e9",
        "storage_key": "property/6767906449167335/019d54f5-5779-720d-8b3f-07c4bc2ff7e9.webp",
        "width": 3072,
        "height": 2305
      },
      "poi_business_url": "https://ferguson.sa.ua.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7188068045896112974&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "student-center-plaza",
      "poi_latitude": "33.2144915",
      "poi_longitude": "-87.5463822",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 205-348-6010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d292-7639-9dd3-9e1447f5fcfb.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f5-d292-7639-9dd3-9e1447f5fcfb",
        "storage_key": "property/6767906449167335/019d54f5-d292-7639-9dd3-9e1447f5fcfb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNxjWT6IChogRTlv5wM0lwWM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "plaza"
    },
    {
      "id": "custom_e69e6f47-0596-420b-a595-07d8407b895f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "Children's Hands-On Museum",
      "poi_type": "Entertainment",
      "poi_address": "2213 University Blvd, Tuscaloosa, AL 35401, USA",
      "poi_short_description": "Play-focused museum featuring a variety of activities relating to space, science, art and imagination.",
      "poi_long_description": "People say this museum offers interactive exhibits and a virtual reality fire truck. They highlight the fun and engaging experience for children, especially those between ages 3-9, and the military discount. They also like the opportunity for families to spend time together.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-62c5-71f5-8c34-908aa5c4df44.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of the Children's Hands-On Museum with brick facade and red doors.",
        "public_id": "019d54f5-62c5-71f5-8c34-908aa5c4df44",
        "storage_key": "property/6767906449167335/019d54f5-62c5-71f5-8c34-908aa5c4df44.webp",
        "width": 1500,
        "height": 1000
      },
      "poi_business_url": "http://www.chomonline.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6622804008205823889&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "childrens-hands-on-museum",
      "poi_latitude": "33.2100905",
      "poi_longitude": "-87.56617969999999",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 205-349-4235",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d291-702e-8bfe-54c36f35fc73.webp",
      "poi_map_icon_media": {
        "alt_text": "Logo featuring the letter M inside a building outline.",
        "public_id": "019d54f5-d291-702e-8bfe-54c36f35fc73",
        "storage_key": "property/6767906449167335/019d54f5-d291-702e-8bfe-54c36f35fc73.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJxWpFr-kChogRkS8kBijt6Fs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_b2718421-e1d4-4e67-aad9-718e95911b54",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "635 Skyland Blvd, Tuscaloosa, AL 35405, USA",
      "poi_short_description": "Chain gym offering access to a variety of equipment, plus tanning beds, and a spa.",
      "poi_long_description": "People say this gym offers a good selection of equipment and is kept clean. They highlight the welcoming and friendly atmosphere, and the helpful staff. They also like the convenient location.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-65e9-77d3-8792-5395e4f19a4d.webp",
      "poi_featured_image_media": {
        "alt_text": "A bright, modern gym with purple machines and various people working out.",
        "public_id": "019d54f5-65e9-77d3-8792-5395e4f19a4d",
        "storage_key": "property/6767906449167335/019d54f5-65e9-77d3-8792-5395e4f19a4d.webp",
        "width": 1920,
        "height": 1080
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/tuscaloosa-skyland-blvd-al?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=16823559078079789117&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "33.16313",
      "poi_longitude": "-87.54593",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 205-506-2717",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d292-7639-9dd3-9e1447f5fcfb.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f5-d292-7639-9dd3-9e1447f5fcfb",
        "storage_key": "property/6767906449167335/019d54f5-d292-7639-9dd3-9e1447f5fcfb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxXETeXsDhogRPXi-sthJeek",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1d462e4b-a1fe-4a31-9062-41614a70ae97",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "Bobby Miller Activity Center",
      "poi_type": "Health and Wellness",
      "poi_address": "300 Bobby Miller Pkwy, Tuscaloosa, AL 35405, USA",
      "poi_short_description": "Gym with a basketball court, swimming pool, and indoor playground, plus water aerobics.",
      "poi_long_description": "People say this gym offers a swimming area with a heated pool, an indoor playground, and a walking track with a woodland view. They also highlight the staff is great and the facilities are nice.\n\nSome reviews mention there can be random closures.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-6f68-726b-ac2d-4544efafba4d.webp",
      "poi_featured_image_media": {
        "alt_text": "Indoor playground structure with multiple levels, slides, and sports-themed decorations.",
        "public_id": "019d54f5-6f68-726b-ac2d-4544efafba4d",
        "storage_key": "property/6767906449167335/019d54f5-6f68-726b-ac2d-4544efafba4d.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.tcpara.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8712573301690500&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bobby-miller-activity-center",
      "poi_latitude": "33.1225581",
      "poi_longitude": "-87.53763359999999",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 205-758-0419",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d292-7639-9dd3-9e1447f5fcfb.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f5-d292-7639-9dd3-9e1447f5fcfb",
        "storage_key": "property/6767906449167335/019d54f5-d292-7639-9dd3-9e1447f5fcfb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR7TpMnWqiIgRhBC6DAr0HgA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b000b2b4-921e-4355-8ccb-c1c517d3a2aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "Crunch Fitness - Tuscaloosa",
      "poi_type": "Health and Wellness",
      "poi_address": "3325 McFarland Blvd E, Tuscaloosa, AL 35405, USA",
      "poi_short_description": "Clean fitness center featuring gym equipment and various group classes.",
      "poi_long_description": "People say this gym offers a variety of equipment and has a friendly atmosphere.\n\nOther reviews mention the gym can be poorly maintained and the equipment can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-6d67-701e-8fb9-99157f466d2d.webp",
      "poi_featured_image_media": {
        "alt_text": "Gym weightlifting area with platforms and machines",
        "public_id": "019d54f5-6d67-701e-8fb9-99157f466d2d",
        "storage_key": "property/6767906449167335/019d54f5-6d67-701e-8fb9-99157f466d2d.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.crunchtuscaloosa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5348310827173536&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---tuscaloosa",
      "poi_latitude": "33.1782586",
      "poi_longitude": "-87.5233567",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 205-737-0738",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d292-7639-9dd3-9e1447f5fcfb.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f5-d292-7639-9dd3-9e1447f5fcfb",
        "storage_key": "property/6767906449167335/019d54f5-d292-7639-9dd3-9e1447f5fcfb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf4EcoMipiIgRoIYAp0IAEwA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d4d799c8-b62d-4d6f-8257-d783416a1001",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "Great Clips",
      "poi_type": "Health and Wellness",
      "poi_address": "1451 Dr Edward Hillard Dr #190, Tuscaloosa, AL 35401, USA",
      "poi_short_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_long_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-70f6-731f-9b47-3481076d0b49.webp",
      "poi_featured_image_media": {
        "alt_text": "Great Clips online check-in app on two iPhones.",
        "public_id": "019d54f5-70f6-731f-9b47-3481076d0b49",
        "storage_key": "property/6767906449167335/019d54f5-70f6-731f-9b47-3481076d0b49.webp",
        "width": 680,
        "height": 383
      },
      "poi_business_url": "https://salons.greatclips.com/us/al/tuscaloosa/1451-dr-edward-hillard-dr?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=4044144513101280435&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "great-clips",
      "poi_latitude": "33.198505",
      "poi_longitude": "-87.52854889999999",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 205-737-7184",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d292-7639-9dd3-9e1447f5fcfb.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f5-d292-7639-9dd3-9e1447f5fcfb",
        "storage_key": "property/6767906449167335/019d54f5-d292-7639-9dd3-9e1447f5fcfb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMUGPNzCoiIgRszS_AwKwHzg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_edfce562-de4c-4f91-9b8a-a1550a736c74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "Animal Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1100 Rice Vly Rd N, Tuscaloosa, AL 35406, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-7537-7647-9b78-87a173f9cbba.webp",
      "poi_featured_image_media": {
        "alt_text": "Two dogs posing in a fenced-in outdoor area with a wooden fence.",
        "public_id": "019d54f5-7537-7647-9b78-87a173f9cbba",
        "storage_key": "property/6767906449167335/019d54f5-7537-7647-9b78-87a173f9cbba.webp",
        "width": 800,
        "height": 313
      },
      "poi_business_url": "https://www.animalmedicalcenteroftuscaloosa.com/?utm_source=gmb&utm_medium=organic&y_source=1_MTE2Njg5NTItNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=8218470337364902321&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "animal-medical-center",
      "poi_latitude": "33.2428832",
      "poi_longitude": "-87.5505792",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 205-758-7295",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d292-7639-9dd3-9e1447f5fcfb.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f5-d292-7639-9dd3-9e1447f5fcfb",
        "storage_key": "property/6767906449167335/019d54f5-d292-7639-9dd3-9e1447f5fcfb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHVD4M04dhogRsUG4fzrfDXI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_697a1575-1012-4967-8343-484c807eb2ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "Tuscaloosa Nails and Spa",
      "poi_type": "Health and Wellness",
      "poi_address": "1800 McFarland Blvd E #117, Tuscaloosa, AL 35404, USA",
      "poi_short_description": "Manicure parlor with a friendly staff also offering pedicures and eyebrow waxing.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-7651-7291-be54-ccb20c3d3c6a.webp",
      "poi_featured_image_media": {
        "alt_text": "Hand with pink and silver glitter nails",
        "public_id": "019d54f5-7651-7291-be54-ccb20c3d3c6a",
        "storage_key": "property/6767906449167335/019d54f5-7651-7291-be54-ccb20c3d3c6a.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://tuscaloosanailsandspa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4490237671646427553&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tuscaloosa-nails-and-spa",
      "poi_latitude": "33.1927074",
      "poi_longitude": "-87.5283419",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 205-343-4313",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d292-7639-9dd3-9e1447f5fcfb.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f5-d292-7639-9dd3-9e1447f5fcfb",
        "storage_key": "property/6767906449167335/019d54f5-d292-7639-9dd3-9e1447f5fcfb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV2ALRTKoiIgRofmPP1-HUD4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_6f093b7d-d166-4201-a1ab-52fe3be7807b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "Greasy Hands Barbershop",
      "poi_type": "Health and Wellness",
      "poi_address": "2008 8th St, Tuscaloosa, AL 35401, USA",
      "poi_short_description": "Relaxed, modern shop for beard trims and cuts, plus hot shaves, near a coffee shop.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-7ddb-726a-89fe-d2d4344f0eb2.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of Greasy Hands Barbershop at night with illuminated sign and interior view.",
        "public_id": "019d54f5-7ddb-726a-89fe-d2d4344f0eb2",
        "storage_key": "property/6767906449167335/019d54f5-7ddb-726a-89fe-d2d4344f0eb2.webp",
        "width": 2048,
        "height": 3072
      },
      "poi_business_url": "http://www.greasyhands.co/tuscaloosa",
      "poi_directions_map_url": "https://maps.google.com/?cid=14258279264201122056&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "greasy-hands-barbershop",
      "poi_latitude": "33.2085781",
      "poi_longitude": "-87.5621238",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d292-7639-9dd3-9e1447f5fcfb.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f5-d292-7639-9dd3-9e1447f5fcfb",
        "storage_key": "property/6767906449167335/019d54f5-d292-7639-9dd3-9e1447f5fcfb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS4JUKD8DhogRCKEGe3KV38U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_afa3066f-f0cd-4e19-ac3a-725cd0031e3f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "YMCA of Tuscaloosa",
      "poi_type": "Health and Wellness",
      "poi_address": "2300 13th St, Tuscaloosa, AL 35401, USA",
      "poi_short_description": "Family-oriented chain featuring a gym, plus social services and activities.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-7e17-70db-b71d-2264048d868c.webp",
      "poi_featured_image_media": {
        "alt_text": "Row of elliptical machines and treadmills in a bright, modern fitness center.",
        "public_id": "019d54f5-7e17-70db-b71d-2264048d868c",
        "storage_key": "property/6767906449167335/019d54f5-7e17-70db-b71d-2264048d868c.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://www.ymcatuscaloosa.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10579575079205678843&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ymca-of-tuscaloosa",
      "poi_latitude": "33.2030604",
      "poi_longitude": "-87.5636024",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 205-345-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d292-7639-9dd3-9e1447f5fcfb.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f5-d292-7639-9dd3-9e1447f5fcfb",
        "storage_key": "property/6767906449167335/019d54f5-d292-7639-9dd3-9e1447f5fcfb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDSEVB-8ChogR-y6hRnsz0pI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_7ceaa28a-15ef-48a9-b046-42bc9b2b5f27",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "DCH Regional Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "809 University Blvd E, Tuscaloosa, AL 35401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-8928-707e-8ebf-ff2e77a2ad01.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a large hospital building at night, with a lit entrance canopy and signage.",
        "public_id": "019d54f5-8928-707e-8ebf-ff2e77a2ad01",
        "storage_key": "property/6767906449167335/019d54f5-8928-707e-8ebf-ff2e77a2ad01.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.dchsystem.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1535150635260651800&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dch-regional-medical-center",
      "poi_latitude": "33.2051666",
      "poi_longitude": "-87.52657099999999",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 205-759-7111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d299-7298-b7aa-8d8161b455d8.webp",
      "poi_map_icon_media": {
        "alt_text": "H logo",
        "public_id": "019d54f5-d299-7298-b7aa-8d8161b455d8",
        "storage_key": "property/6767906449167335/019d54f5-d299-7298-b7aa-8d8161b455d8.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJGww57zuoiIgRGCltg17zTRU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_26a5bc21-ba2d-4577-8ffd-3ea9f2e19c9d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "Tuscaloosa Veterans Affairs Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "3701 Loop Rd, Tuscaloosa, AL 35404, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-89fb-768c-8ec0-d73b27497c82.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of a large, red brick building with an American flag flying.",
        "public_id": "019d54f5-89fb-768c-8ec0-d73b27497c82",
        "storage_key": "property/6767906449167335/019d54f5-89fb-768c-8ec0-d73b27497c82.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.tuscaloosa.va.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9860951663517340171&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tuscaloosa-veterans-affairs-medical-center",
      "poi_latitude": "33.1898366",
      "poi_longitude": "-87.48812269999999",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 205-554-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d2de-74cc-88e6-5d6c443c0072.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon",
        "public_id": "019d54f5-d2de-74cc-88e6-5d6c443c0072",
        "storage_key": "property/6767906449167335/019d54f5-d2de-74cc-88e6-5d6c443c0072.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ93MpS-KoiIgRC5I_20oj2Yg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_b5d3fe69-64f0-4305-9e13-4abef771a1b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "Tuscaloosa River Walk",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2710 Jack Warner Pkwy, Tuscaloosa, AL 35401, USA",
      "poi_short_description": "Concrete, paved walkway stretching several miles along the Black Warrior River.",
      "poi_long_description": "People say this park offers a scenic walking trail along the river, with beautiful views and a peaceful atmosphere. They highlight the well-maintained path, clean restrooms, and ample shade, making it a great place for relaxation and recreation. They also like the safe and well-lit environment, suitable for people of all ages and abilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-93ab-74f5-adfa-abb2ede595b3.webp",
      "poi_featured_image_media": {
        "alt_text": "Waterfront walkway with stairs, benches, and lush green grass overlooking a wide river on a sunny day.",
        "public_id": "019d54f5-93ab-74f5-adfa-abb2ede595b3",
        "storage_key": "property/6767906449167335/019d54f5-93ab-74f5-adfa-abb2ede595b3.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1450030249362743511&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tuscaloosa-river-walk",
      "poi_latitude": "33.2121842",
      "poi_longitude": "-87.57551",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 205-562-3220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d2dc-726a-b147-cffd79bb6a10.webp",
      "poi_map_icon_media": {
        "alt_text": "Black icon of a pine tree",
        "public_id": "019d54f5-d2dc-726a-b147-cffd79bb6a10",
        "storage_key": "property/6767906449167335/019d54f5-d2dc-726a-b147-cffd79bb6a10.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJPSOQv8IChogR12DWRtSKHxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c60954ea-c44b-4e83-a9d8-0f765fe01ff0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "Bowers Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1600 James I Harrison Jr Pkwy, Tuscaloosa, AL 35405, USA",
      "poi_short_description": "Recreational park featuring baseball fields and a disc golf course plus a playground and swings.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-8f5e-74ce-89ba-a5ed931d622e.webp",
      "poi_featured_image_media": {
        "alt_text": "Playground with slides and climbing structures.",
        "public_id": "019d54f5-8f5e-74ce-89ba-a5ed931d622e",
        "storage_key": "property/6767906449167335/019d54f5-8f5e-74ce-89ba-a5ed931d622e.webp",
        "width": 2992,
        "height": 2992
      },
      "poi_business_url": "https://www.tcpara.org/p/bowers-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=7784840114637624124&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bowers-park",
      "poi_latitude": "33.1753604",
      "poi_longitude": "-87.5164964",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 205-562-3210",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d2dc-726a-b147-cffd79bb6a10.webp",
      "poi_map_icon_media": {
        "alt_text": "Black icon of a pine tree",
        "public_id": "019d54f5-d2dc-726a-b147-cffd79bb6a10",
        "storage_key": "property/6767906449167335/019d54f5-d2dc-726a-b147-cffd79bb6a10.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJrbLoprmpiIgRPNMvotZOCWw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_407e776e-e665-4bd0-be31-0a2f1ad9999a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "Park at Manderson Landing",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "69 Jack Warner Pkwy, Tuscaloosa, AL 35401, USA",
      "poi_short_description": "Scenic park along the Black Warrior River featuring a bike path and picnic tables.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-b5a9-706d-8c56-db9bc3158d61.webp",
      "poi_featured_image_media": {
        "alt_text": "Signage for The Park at Manderson Landing, with the University of Alabama text above. Features fall foliage and landscaping.",
        "public_id": "019d54f5-b5a9-706d-8c56-db9bc3158d61",
        "storage_key": "property/6767906449167335/019d54f5-b5a9-706d-8c56-db9bc3158d61.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://visittuscaloosa.com/tag/manderson-landing/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14980648435744632403&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "park-at-manderson-landing",
      "poi_latitude": "33.2210794",
      "poi_longitude": "-87.5466511",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 205-391-9200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d2dc-726a-b147-cffd79bb6a10.webp",
      "poi_map_icon_media": {
        "alt_text": "Black icon of a pine tree",
        "public_id": "019d54f5-d2dc-726a-b147-cffd79bb6a10",
        "storage_key": "property/6767906449167335/019d54f5-d2dc-726a-b147-cffd79bb6a10.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJt1mntqUChogRU-6RpWH05c8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7b9763b6-f856-41a5-ab1c-ddc143ea8f66",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "Snow Hinton Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Hinton Pk Dr, Tuscaloosa, AL 35404, USA",
      "poi_short_description": "Rentable picnic pavilions, walking trails & a massive jungle gym for older kids.",
      "poi_long_description": "Rentable picnic pavilions, walking trails & a massive jungle gym for older kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-9a40-739e-aab0-93cacb2a5478.webp",
      "poi_featured_image_media": {
        "alt_text": "Playground with a large climbing structure and slide.",
        "public_id": "019d54f5-9a40-739e-aab0-93cacb2a5478",
        "storage_key": "property/6767906449167335/019d54f5-9a40-739e-aab0-93cacb2a5478.webp",
        "width": 2313,
        "height": 3072
      },
      "poi_business_url": "https://elevatetuscaloosa.com/completed-parks-and-recreation/snow-hinton-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1769453473963298797&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "snow-hinton-park",
      "poi_latitude": "33.1886308",
      "poi_longitude": "-87.5241296",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 205-562-3210",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d2dc-726a-b147-cffd79bb6a10.webp",
      "poi_map_icon_media": {
        "alt_text": "Black icon of a pine tree",
        "public_id": "019d54f5-d2dc-726a-b147-cffd79bb6a10",
        "storage_key": "property/6767906449167335/019d54f5-d2dc-726a-b147-cffd79bb6a10.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJAx5iVMupiIgR7c8pQo9cjhg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_886b7da2-dc01-41fb-9c22-99d4a7205c44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "Government Plaza",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "618 Almon Ave, Tuscaloosa, AL 35401, USA",
      "poi_short_description": "Large park with grassy lawns and sidewalks, as well as a fountain, a gazebo and art festivals.",
      "poi_long_description": "People say this park offers beautiful decorations, trees, and an ice rink. They highlight the easy access, convenient parking, and fun, free events. They also like the clean, quiet, and relaxing atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-aeaa-74af-84f4-c41a8b4e9e5c.webp",
      "poi_featured_image_media": {
        "alt_text": "Decorated Christmas trees at night.",
        "public_id": "019d54f5-aeaa-74af-84f4-c41a8b4e9e5c",
        "storage_key": "property/6767906449167335/019d54f5-aeaa-74af-84f4-c41a8b4e9e5c.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://liveplaytuscaloosa.com/city-events/live-at-the-plaza",
      "poi_directions_map_url": "https://maps.google.com/?cid=9689302309454325400&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "government-plaza",
      "poi_latitude": "33.2092853",
      "poi_longitude": "-87.564505",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 205-248-5311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d2dc-726a-b147-cffd79bb6a10.webp",
      "poi_map_icon_media": {
        "alt_text": "Black icon of a pine tree",
        "public_id": "019d54f5-d2dc-726a-b147-cffd79bb6a10",
        "storage_key": "property/6767906449167335/019d54f5-d2dc-726a-b147-cffd79bb6a10.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7RBdfOkChogRmKZlRB1Rd4Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8c917d6c-ec29-409e-9739-dd3012abead0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "Tuscaloosa National Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "7601 R, Robert Cardinal Airport Rd, Tuscaloosa, AL 35401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-b0e9-776a-838e-e7d0ad7282eb.webp",
      "poi_featured_image_media": {
        "alt_text": "Aerial view of an airport runway and surrounding buildings.",
        "public_id": "019d54f5-b0e9-776a-838e-e7d0ad7282eb",
        "storage_key": "property/6767906449167335/019d54f5-b0e9-776a-838e-e7d0ad7282eb.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://airport.tuscaloosa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1011281629023253230&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tuscaloosa-national-airport",
      "poi_latitude": "33.2210007",
      "poi_longitude": "-87.60965809999999",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 14 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 205-248-5300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d6c7-71e5-abbf-7f3bfafed7d7.webp",
      "poi_map_icon_media": {
        "alt_text": "Airplane icon",
        "public_id": "019d54f5-d6c7-71e5-abbf-7f3bfafed7d7",
        "storage_key": "property/6767906449167335/019d54f5-d6c7-71e5-abbf-7f3bfafed7d7.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJlYfQFlwDhogR7jLPmUjLCA4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_62db0ebd-2707-419c-abff-825bcf585009",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "Tuscaloosa",
      "poi_type": "Transportation & Transit",
      "poi_address": "2105 Greensboro Ave, Tuscaloosa, AL 35401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-9dcc-7689-9dc9-3e43d679a366.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of the historic Tuscaloosa train station building with a large covered porch and parking lot.",
        "public_id": "019d54f5-9dcc-7689-9dc9-3e43d679a366",
        "storage_key": "property/6767906449167335/019d54f5-9dcc-7689-9dc9-3e43d679a366.webp",
        "width": 500,
        "height": 369
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=TCL",
      "poi_directions_map_url": "https://maps.google.com/?cid=17820195675061288257&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tuscaloosa",
      "poi_latitude": "33.1933121",
      "poi_longitude": "-87.5601934",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d6f1-76d2-828f-5a61030f36cf.webp",
      "poi_map_icon_media": {
        "alt_text": "Train icon",
        "public_id": "019d54f5-d6f1-76d2-828f-5a61030f36cf",
        "storage_key": "property/6767906449167335/019d54f5-d6f1-76d2-828f-5a61030f36cf.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJt5Z-JfUChogRQf36D40NTvc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_c77cea3d-4951-4584-82d9-2073f70c2c9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "Tuscaloosa City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2201 University Blvd, Tuscaloosa, AL 35401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-9e9f-74e7-9afb-2fed9cd0ebdf.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of the property's grand brick building with white columns and arched windows.",
        "public_id": "019d54f5-9e9f-74e7-9afb-2fed9cd0ebdf",
        "storage_key": "property/6767906449167335/019d54f5-9e9f-74e7-9afb-2fed9cd0ebdf.webp",
        "width": 1600,
        "height": 1200
      },
      "poi_business_url": "http://www.tuscaloosa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4677114282996791848&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tuscaloosa-city-hall",
      "poi_latitude": "33.2102554",
      "poi_longitude": "-87.56586589999999",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 205-248-5311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d2de-74cc-88e6-5d6c443c0072.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon",
        "public_id": "019d54f5-d2de-74cc-88e6-5d6c443c0072",
        "storage_key": "property/6767906449167335/019d54f5-d2de-74cc-88e6-5d6c443c0072.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdQxqoekChogRKPrt86hy6EA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_05369265-58dd-4824-9b4f-fc32a413b3ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "Northport City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3500 McFarland Blvd, Northport, AL 35476, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-b933-727b-919d-66caa3011f97.webp",
      "poi_featured_image_media": {
        "alt_text": "City Hall of Northport with flags and clear blue sky.",
        "public_id": "019d54f5-b933-727b-919d-66caa3011f97",
        "storage_key": "property/6767906449167335/019d54f5-b933-727b-919d-66caa3011f97.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.cityofnorthport.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1576974359661598722&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "northport-city-hall",
      "poi_latitude": "33.2408322",
      "poi_longitude": "-87.59226559999999",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 205-339-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d2de-74cc-88e6-5d6c443c0072.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon",
        "public_id": "019d54f5-d2de-74cc-88e6-5d6c443c0072",
        "storage_key": "property/6767906449167335/019d54f5-d2de-74cc-88e6-5d6c443c0072.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFYKG5M0chogRAliHL9OJ4hU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_d395ed0d-4b21-4dfc-a6c1-4d047011a090",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "Cahaba Truck And Equipment",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10992 Commercial Dr, Tuscaloosa, AL 35405, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-b170-731e-adee-f48b860da2d0.webp",
      "poi_featured_image_media": {
        "alt_text": "The Cahaba logo featuring a green leaf-like shape above the name \"CAHABA\" on a burlap background.",
        "public_id": "019d54f5-b170-731e-adee-f48b860da2d0",
        "storage_key": "property/6767906449167335/019d54f5-b170-731e-adee-f48b860da2d0.webp",
        "width": 700,
        "height": 500
      },
      "poi_business_url": "https://cahabatruck.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3433795218612259514&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cahaba-truck-and-equipment",
      "poi_latitude": "33.0939368",
      "poi_longitude": "-87.562461",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 205-752-3893",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d292-7639-9dd3-9e1447f5fcfb.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f5-d292-7639-9dd3-9e1447f5fcfb",
        "storage_key": "property/6767906449167335/019d54f5-d292-7639-9dd3-9e1447f5fcfb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVUTneUkAhogRuorR7I5Kpy8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_e7cf2659-f8f0-4a8a-ae09-3e0ad4d9ebc8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "ST Bunn's New Hot Plant",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Tuscaloosa, AL 35401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17005351389452890171&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "st-bunns-new-hot-plant",
      "poi_latitude": "33.1591453",
      "poi_longitude": "-87.5985412",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d292-7639-9dd3-9e1447f5fcfb.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f5-d292-7639-9dd3-9e1447f5fcfb",
        "storage_key": "property/6767906449167335/019d54f5-d292-7639-9dd3-9e1447f5fcfb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz4fKY8IDhogRO_AIkf0k_-s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_e5cae278-a264-4a61-8fa0-c5b4dc9995b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "poi_name": "Taco Casa",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1060 Fairfax Park Suite A, Tuscaloosa, AL 35406, USA",
      "poi_short_description": "Local counter-serve chain offering a menu of classic Mexican dishes in low-key surroundings.",
      "poi_long_description": "Local counter-serve chain offering a menu of classic Mexican dishes in low-key surroundings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-b1ad-74dd-9636-7c47fb30eda0.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of a two-story brick building with a covered entrance and parking lot.",
        "public_id": "019d54f5-b1ad-74dd-9636-7c47fb30eda0",
        "storage_key": "property/6767906449167335/019d54f5-b1ad-74dd-9636-7c47fb30eda0.webp",
        "width": 600,
        "height": 450
      },
      "poi_business_url": "https://www.tacocasa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15926723734260712091&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "taco-casa",
      "poi_latitude": "33.2393709",
      "poi_longitude": "-87.5507287",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 205-752-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-d292-7639-9dd3-9e1447f5fcfb.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f5-d292-7639-9dd3-9e1447f5fcfb",
        "storage_key": "property/6767906449167335/019d54f5-d292-7639-9dd3-9e1447f5fcfb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ39yR6k0dhogRm4JkWNoWB90",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_f1764860-bb3a-4a21-96a8-1a48fa324d5b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_007e3237-fb0b-4755-936e-7f338e7ef754",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_f75916ac-e3f9-4690-8626-4de7105dd5b8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_48999a3e-993b-410f-a03a-05d656ba95bf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_79578b21-f41c-4a52-8636-9a2e3d8106cb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_bfd16a78-1da5-4ab9-93fb-a80d1397928b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "rating": "5.0",
      "name": "Sebastian Farias",
      "text": "MY MOVE IN EXPERIENCE:\n\nI just want to start off by thanking Brett and Angie for the welcoming and helpful environment that they have created at this complex. From beginning the application process to getting the keys to the unit and to settling in, they have been nothing short from amazing. They have made this whole experience very smooth and easy. I initially had to make some last minute decisions on my time frame for move in. That did not stop their staff from being accommodating. Upon move in, I quickly realized that the unit was spotless. It practically looked like a brand new constructed building. That should give you an idea on the pride they take in making sure every unit is ready for its next resident. The in unit laundry appliances and ready to go internet connections made the process seamless. After a couple nights at the residence, I have noticed that it is a very quiet and calm area, which is greatly appreciated. If you are looking to move in to The Gates At South Bend, I 100% would agree that you should make the move. From the friendly staff to the spacious units, it is a place worth moving to.",
      "date": "2025-12-15",
      "title": ""
    },
    {
      "id": "custom_7e1b73f9-af50-4b73-b666-803db32989f8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "rating": "5.0",
      "name": "grace elmore",
      "text": "the team they have is really great and hard working! they strive to make sure you’re satisfied. the maintenance workers Demetric and Aaron do their job the right way and in a timely manner! Angie and Brett make you feel at home and are great with communication.",
      "date": "2026-02-04",
      "title": ""
    },
    {
      "id": "custom_342b0e06-7fb2-4b51-a75c-47eb27227722",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "rating": "5.0",
      "name": "clair williams",
      "text": "The process from start to move in was a pleasant experience. The process was fast efficient and professional. The leasing staff Brent and Angie were a pleasure to work . The maintenance crew response time was quick for a minor issue I had and the work was top notch. And the apartment is great  Thank you",
      "date": "2026-02-03",
      "title": ""
    },
    {
      "id": "custom_c6e12cdd-a993-40ed-8203-15be9ea4ba27",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "rating": "5.0",
      "name": "Trinity Simmons",
      "text": "Brett at the leasing office is an amazing guy. From the very beginning of my fiancé and I searching for a place to move to he has been extremely helpful answering all of our questions and getting us moved in quickly. Since we have been living here we have only had to put in two maintenance request and within less than an hour someone was at our door ready to fix the issue. Overall it seems like management here really looks after their residents and provides a safe, clean environment for all. I would recommend any and everyone who is looking for a place to move to, to consider the gates!",
      "date": "2025-10-09",
      "title": ""
    },
    {
      "id": "custom_096ccefd-37c5-4ef0-8f19-6de7261aa9a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "rating": "5.0",
      "name": "Amanda Seda",
      "text": "Ms. Angie and Aaron are amazing. If I have a maintenance issue they respond immediately. They are amazing and kind people and have treated my family so well since moving here. Love the environment and it’s very family friendly.",
      "date": "2025-10-23",
      "title": ""
    },
    {
      "id": "custom_b9c7e130-cc93-47d1-b89d-b66e547e1f60",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "rating": "5.0",
      "name": "grace elmore",
      "text": "the team they have is really great and hard working! they strive to make sure you’re satisfied. the maintenance workers Demetric and Aaron do their job the right way and in a timely manner! Angie and Brett make you feel at home and are great with communication.",
      "date": "2026-02-04",
      "title": ""
    },
    {
      "id": "custom_9d5374d9-afe5-4af9-abc6-34018ab018aa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "rating": "5.0",
      "name": "J. WARREN",
      "text": "Good place, nice and friendly staff\nAngie has been nothing but nice since moving in. Aaron the maintenance manager is always prompt and professional.\nBrett was a great addition to the team as well. Brett Angie and Aaron are awesome!!!",
      "date": "2026-06-09",
      "title": ""
    },
    {
      "id": "custom_5070aef9-121d-453a-a5de-7962f19ae208",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "rating": "5.0",
      "name": "Tristian Abrams",
      "text": "Amazing team. Outstanding actually. Office is always very responsive. Maintenance team responds quickly and are very helpful. Gates are ALWAYS working. Community is quiet and well kept as well. One of the hidden gems of Tuscaloosa.",
      "date": "2026-06-24",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_2fdfbeed-7198-4fca-bced-8332500aba43",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f7-834d-736f-b16f-0a5e61469af5.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d54f7-834d-736f-b16f-0a5e61469af5",
        "storage_key": "property/6767906449167335/019d54f7-834d-736f-b16f-0a5e61469af5.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR - 1BA, 1127SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=hxmL2e4DnHR"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019db23f-cf9f-7142-927b-ee2f9f6ce4af",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Gates at South Bend Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335"
    },
    {
      "lead_collector_id": "019db23f-d015-702b-85c1-e2d6ff8b6092",
      "lead_source": "FACEBOOK_ADS",
      "name": "Gates at South Bend Facebook Ads",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335"
    },
    {
      "lead_collector_id": "019db23f-d084-7033-9b52-32a75a92b385",
      "lead_source": "LANDING_PAGE",
      "name": "Gates at South Bend Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "page_item_url": "in-unit-laundry-apartments-tuscaloosa",
      "search_query": "apartments with in-unit laundry Tuscaloosa",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Tuscaloosa",
      "h2_subtitle": "Discover the convenience of in-unit laundry right here in Tuscaloosa. Enjoy hassle-free living at The Gates at South Bend with provided washers and dryers.",
      "page_copy": "The Gates at South Bend offers the perfect solution for those seeking apartments with in-unit laundry in Tuscaloosa. Our community includes the convenience of washers and dryers in every unit, eliminating the hassle of shared laundry facilities. Located in the heart of Tuscaloosa County, our residents enjoy easy access to local amenities and attractions.\n\nOur gated community provides a comfortable living environment with excellent amenities such as a playground for leisure. The spacious first-floor apartments offer modern conveniences without sacrificing comfort. Experience the ease of in-unit laundry and upscale living at The Gates at South Bend, where everything you need is right at your fingertips.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-a6ca-76ae-b81f-9fe284348903.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the apartment building.",
        "public_id": "019d54f5-a6ca-76ae-b81f-9fe284348903",
        "storage_key": "property/6767906449167335/019d54f5-a6ca-76ae-b81f-9fe284348903.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry - Tuscaloosa",
      "seo_description": "Find apartments with in-unit laundry in Tuscaloosa at The Gates at South Bend. Enjoy the convenience of a washer and dryer in your own home.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "page_item_url": "gated-community-apartments-tuscaloosa-al",
      "search_query": "gated community apartments Tuscaloosa AL",
      "category": "Amenity",
      "h1_title": "Gated Community Apartments in Tuscaloosa, AL",
      "h2_subtitle": "Experience security and tranquility in a gated community. Explore The Gates at South Bend, a premier apartment complex in Tuscaloosa, AL.",
      "page_copy": "Discover the security and serenity of gated community apartments at The Gates at South Bend in Tuscaloosa, AL. Our access gates ensure peace of mind for our residents. Nestled in vibrant Tuscaloosa County, our community offers the perfect blend of convenience and tranquility.\n\nResidents at The Gates at South Bend enjoy a multitude of amenities including a playground and in-unit laundry facilities. The first-floor layouts are designed with your comfort in mind, providing ease of access and spacious living areas. Join us and see why our gated community is a top choice for those seeking apartments in Tuscaloosa, AL.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-a6ca-76ae-b81f-9fe284348903.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the apartment building.",
        "public_id": "019d54f5-a6ca-76ae-b81f-9fe284348903",
        "storage_key": "property/6767906449167335/019d54f5-a6ca-76ae-b81f-9fe284348903.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gated Community Apartments - Tuscaloosa, AL",
      "seo_description": "Find comfort in gated community apartments in Tuscaloosa, AL, at The Gates at South Bend. Access gates and modern amenities await you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "page_item_url": "apartments-with-playground-tuscaloosa-county",
      "search_query": "apartments with playground in Tuscaloosa County",
      "category": "Amenity",
      "h1_title": "Apartments with Playground in Tuscaloosa County",
      "h2_subtitle": "Enjoy living with a playground on-site. Discover The Gates at South Bend for amenities in Tuscaloosa County.",
      "page_copy": "Explore living at The Gates at South Bend, featuring apartments with a playground in Tuscaloosa County. Our community is designed for those who value convenience and fun all in one place. \n\nIn addition to the playground, our apartments come equipped with in-unit laundry facilities and are located on the first floor, providing easy access and modern convenience. Nestled in the welcoming environment of Tuscaloosa County, our gated community ensures you’ll enjoy a vibrant lifestyle. Experience all the advantages of living at The Gates at South Bend.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-a6ca-76ae-b81f-9fe284348903.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the apartment building.",
        "public_id": "019d54f5-a6ca-76ae-b81f-9fe284348903",
        "storage_key": "property/6767906449167335/019d54f5-a6ca-76ae-b81f-9fe284348903.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Playground - Tuscaloosa County",
      "seo_description": "Discover apartments with a playground in Tuscaloosa County at The Gates at South Bend. Enjoy convenience in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "page_item_url": "furnished-apartments-tuscaloosa-35405",
      "search_query": "furnished apartments in Tuscaloosa 35405",
      "category": "Amenity",
      "h1_title": "Furnished Apartments in Tuscaloosa, 35405",
      "h2_subtitle": "Move into comfort with furnished apartments in Tuscaloosa's 35405 area. Experience ready-to-live-in convenience at The Gates at South Bend.",
      "page_copy": "Welcome to The Gates at South Bend, your destination for furnished apartments in Tuscaloosa, 35405. Our community offers residents the ease of moving into a fully ready apartment, saving you the time and effort of furnishing yourself. Each unit is thoughtfully equipped to provide comfort, allowing you to settle in and start living from day one.\n\nLocated in the heart of Tuscaloosa County, our apartments provide additional amenities such as in-unit laundry facilities and a community playground, all within our gated environment. Designed for convenience and comfort, The Gates at South Bend is the ideal choice for those seeking furnished living in Tuscaloosa. Enjoy a seamless transition to a new home today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-a6ca-76ae-b81f-9fe284348903.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the apartment building.",
        "public_id": "019d54f5-a6ca-76ae-b81f-9fe284348903",
        "storage_key": "property/6767906449167335/019d54f5-a6ca-76ae-b81f-9fe284348903.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Furnished Apartments - Tuscaloosa, 35405",
      "seo_description": "Find comfortable furnished apartments in Tuscaloosa, 35405 at The Gates at South Bend. Move right in and enjoy a fully-equipped living experience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "page_item_url": "wood-style-flooring-apartments-tuscaloosa",
      "search_query": "wood-style flooring apartments Tuscaloosa",
      "category": "Amenity",
      "h1_title": "Wood-Style Flooring Apartments in Tuscaloosa",
      "h2_subtitle": "Experience elegance with wood-style flooring in our Tuscaloosa apartments. Discover The Gates at South Bend for modern living.",
      "page_copy": "At The Gates at South Bend, elegance meets functionality with our wood-style flooring apartments in Tuscaloosa. Offering a sleek and modern aesthetic, these floors are designed to enhance the beauty of each room while providing easy maintenance and durability.\n\nSituated in the inviting community of Tuscaloosa County, our apartments come with a host of amenities such as in-unit washers and dryers and access to a playground. Discover the perfect blend of style, comfort, and convenience at The Gates at South Bend.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-a6ca-76ae-b81f-9fe284348903.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the apartment building.",
        "public_id": "019d54f5-a6ca-76ae-b81f-9fe284348903",
        "storage_key": "property/6767906449167335/019d54f5-a6ca-76ae-b81f-9fe284348903.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Wood-Style Flooring Apartments - Tuscaloosa",
      "seo_description": "Discover modern living with wood-style flooring in Tuscaloosa apartments at The Gates at South Bend. Style and convenience combined.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-tuscaloosa-al",
      "search_query": "two bedroom apartments tuscaloosa al",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Tuscaloosa, AL",
      "h2_subtitle": "Find spacious two-bedroom apartments in Tuscaloosa, AL. The Gates at South Bend offers the perfect blend of comfort and community.",
      "page_copy": "Discover the spacious and comfortable two-bedroom apartments at The Gates at South Bend in Tuscaloosa, AL. These apartments offer ample space for all your needs. Enjoy modern amenities, including an in-unit washer and dryer, ensuring daily chores are handled with ease.\n\nLocated in the welcoming environment of Tuscaloosa, our community also features a gated entrance and a playground. Positioned on the first floor for easy access, these apartments provide both convenience and security. Choose The Gates at South Bend for a living experience that balances comfort, style, and practicality.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-a6ca-76ae-b81f-9fe284348903.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the apartment building.",
        "public_id": "019d54f5-a6ca-76ae-b81f-9fe284348903",
        "storage_key": "property/6767906449167335/019d54f5-a6ca-76ae-b81f-9fe284348903.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments - Tuscaloosa, AL",
      "seo_description": "Explore two-bedroom apartments in Tuscaloosa, AL at The Gates at South Bend. Spacious living with modern amenities in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "page_item_url": "three-bedroom-rentals-near-35405",
      "search_query": "three bedroom rentals near 35405",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Rentals Near 35405",
      "h2_subtitle": "Explore spacious three-bedroom rentals near 35405 at The Gates at South Bend. Ideal for those seeking comfort and community.",
      "page_copy": "Looking for spacious living options near the 35405 area? The Gates at South Bend offers three-bedroom rentals that perfectly blend comfort and functionality. These rentals are ideal for those desiring ample space, combining modern living with homely warmth.\n\nOur community is nestled in the vibrant Tuscaloosa County, featuring essential amenities such as a playground and in-unit washer and dryer. Easy access gates and the first-floor units ensure convenience for all family members. Discover a new level of living with these generously spaced three-bedroom homes.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-a6ca-76ae-b81f-9fe284348903.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the apartment building.",
        "public_id": "019d54f5-a6ca-76ae-b81f-9fe284348903",
        "storage_key": "property/6767906449167335/019d54f5-a6ca-76ae-b81f-9fe284348903.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Rentals - Near 35405",
      "seo_description": "Discover three-bedroom rentals near 35405 at The Gates at South Bend. Spacious living with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "page_item_url": "apartments-near-university-of-alabama-tuscaloosa",
      "search_query": "apartments near The University of Alabama Tuscaloosa",
      "category": "School",
      "h1_title": "Apartments Near The University of Alabama",
      "h2_subtitle": "Discover convenient living with our apartments near The University of Alabama. The Gates at South Bend offers ideal amenities.",
      "page_copy": "The Gates at South Bend provides exceptional apartments near The University of Alabama, making it a prime choice for those seeking off-campus housing. Enjoy the convenience of being just a short commute away from campus while experiencing a peaceful community environment.\n\nOur apartments come with modern features like in-unit washers and dryers and secure access gates, adding layers of convenience and safety. The community also includes a playground for moments of relaxation and recreation. Choose The Gates at South Bend for a harmonious blend of academic focus and comfortable living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-a6ca-76ae-b81f-9fe284348903.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the apartment building.",
        "public_id": "019d54f5-a6ca-76ae-b81f-9fe284348903",
        "storage_key": "property/6767906449167335/019d54f5-a6ca-76ae-b81f-9fe284348903.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near The University of Alabama",
      "seo_description": "Find apartments near The University of Alabama at The Gates at South Bend. Convenient living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "page_item_url": "shelton-state-community-college-nearby-apartments-al",
      "search_query": "Shelton State Community College nearby apartments AL",
      "category": "School",
      "h1_title": "Nearby Apartments AL Shelton State Community",
      "h2_subtitle": "Discover convenient living at The Gates at South Bend. Our community offers nearby apartments for those attending Shelton State Community College in AL.",
      "page_copy": "For those at Shelton State Community College seeking nearby apartments in AL, The Gates at South Bend is an ideal choice. Our community offers a quiet, study-friendly environment just a short drive from the campus, making it perfect for those who value proximity and comfort.\n\nEach apartment is equipped with essential amenities such as a washer and dryer, and our access gates provide a secure living experience. Enjoy the added advantage of a first-floor living option and a playground for unwinding after a day on campus. Experience a balanced lifestyle that complements your academic and personal needs at The Gates at South Bend.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-a6ca-76ae-b81f-9fe284348903.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the apartment building.",
        "public_id": "019d54f5-a6ca-76ae-b81f-9fe284348903",
        "storage_key": "property/6767906449167335/019d54f5-a6ca-76ae-b81f-9fe284348903.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Nearby Apartments AL - Shelton State Community",
      "seo_description": "Explore nearby apartments for Shelton State Community College at The Gates at South Bend. Convenient AL living with top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "page_item_url": "paul-w-bryant-museum-tuscaloosa-county-apartments",
      "search_query": "Paul W. Bryant Museum Tuscaloosa County apartments",
      "category": "School",
      "h1_title": "Apartments Near Paul W. Bryant Museum",
      "h2_subtitle": "Find the perfect home near Paul W. Bryant Museum. The Gates at South Bend offers welcoming apartments in Tuscaloosa County.",
      "page_copy": "Enjoy living in proximity to the rich history of the Paul W. Bryant Museum with The Gates at South Bend apartments. Situated in Tuscaloosa County, our community provides a perfect blend of comfort and convenience, ideal for those wanting quick access to local attractions.\n\nOur apartments feature modern amenities including a washer and dryer in each unit and secure access gates. Whether you're a museum enthusiast or simply appreciate being close to the vibrant culture of Tuscaloosa, our community location offers the lifestyle and ease you seek. Plus, enjoy community perks like a playground for relaxation and recreation right at home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-a6ca-76ae-b81f-9fe284348903.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the apartment building.",
        "public_id": "019d54f5-a6ca-76ae-b81f-9fe284348903",
        "storage_key": "property/6767906449167335/019d54f5-a6ca-76ae-b81f-9fe284348903.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Tuscaloosa County Apartments Near Paul W. Bryant Museum",
      "seo_description": "Discover Tuscaloosa County apartments near Paul W. Bryant Museum at The Gates at South Bend. Experience modern living close to local attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "page_item_url": "stillman-college-area-apartments-tuscaloosa",
      "search_query": "Stillman College area apartments Tuscaloosa",
      "category": "School",
      "h1_title": "Apartments Near Stillman College Tuscaloosa",
      "h2_subtitle": "Looking for Stillman College area apartments in Tuscaloosa? The Gates at South Bend offers an ideal living experience close to campus.",
      "page_copy": "Residents seeking apartments near Stillman College in Tuscaloosa will find The Gates at South Bend provides an ideal living environment. Our community offers easy access to the college, ensuring that your academic commitments are just a short drive away.\n\nWith essential amenities such as in-unit washers and dryers and secure access gates, our apartments cater to convenience. Enjoy recreational features like our on-site playground, perfect for relaxation and leisure outside of study hours. Choose The Gates at South Bend to experience a balanced and fulfilling college lifestyle in Tuscaloosa.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-a6ca-76ae-b81f-9fe284348903.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the apartment building.",
        "public_id": "019d54f5-a6ca-76ae-b81f-9fe284348903",
        "storage_key": "property/6767906449167335/019d54f5-a6ca-76ae-b81f-9fe284348903.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Tuscaloosa Apartments Near Stillman College",
      "seo_description": "Explore Tuscaloosa apartments near Stillman College at The Gates at South Bend. Convenient living with top features.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "page_item_url": "bryant-conference-center-close-apartments-35405",
      "search_query": "Bryant Conference Center close apartments 35405",
      "category": "School",
      "h1_title": "Apartments Near Bryant Conference Center",
      "h2_subtitle": "Looking for close apartments in 35405? Discover The Gates at South Bend, a perfect home near the Bryant Conference Center.",
      "page_copy": "The Gates at South Bend offers the ideal place for those attending events at the Bryant Conference Center. Located in the heart of the 35405 area, our apartments provide both comfort and proximity, making commuting effortless.\n\nEach apartment comes equipped with a washer and dryer, ensuring convenience is at your fingertips. Our secure access gates and the option of first-floor units add to the ease of living here. Plus, the community playground invites relaxation after a busy day. Discover a balanced lifestyle and enjoy the benefits of being close to the Bryant Conference Center by choosing The Gates at South Bend.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-a6ca-76ae-b81f-9fe284348903.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the apartment building.",
        "public_id": "019d54f5-a6ca-76ae-b81f-9fe284348903",
        "storage_key": "property/6767906449167335/019d54f5-a6ca-76ae-b81f-9fe284348903.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Close Apartments 35405 - Near Bryant Conference Center",
      "seo_description": "Find 35405 close apartments near Bryant Conference Center at The Gates at South Bend. Experience convenient amenities and easy event access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "page_item_url": "apartments-near-dch-regional-medical-center-tuscaloosa-al",
      "search_query": "apartments near DCH Regional Medical Center Tuscaloosa AL",
      "category": "Hospital",
      "h1_title": "Apartments Near DCH Regional Medical Center",
      "h2_subtitle": "Discover our community in Tuscaloosa, AL. Located near DCH Regional Medical Center, The Gates at South Bend offers convenience and comfort.",
      "page_copy": "Situated just a short drive from DCH Regional Medical Center, The Gates at South Bend provides a perfect location for those seeking nearby accommodations. Our apartments in Tuscaloosa, AL, ensure that daily commutes are easy and stress-free.\n\nResidents will appreciate the modern amenities, including in-unit washers and dryers and secure access gates. The community playground offers an excellent spot for relaxation and unwinding. Whether you're working at the medical center or visiting, The Gates at South Bend offers a comfortable and convenient home base.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-a6ca-76ae-b81f-9fe284348903.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the apartment building.",
        "public_id": "019d54f5-a6ca-76ae-b81f-9fe284348903",
        "storage_key": "property/6767906449167335/019d54f5-a6ca-76ae-b81f-9fe284348903.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Tuscaloosa AL Apartments Near DCH Regional Medical Center",
      "seo_description": "Explore Tuscaloosa AL apartments near DCH Regional Medical Center at The Gates at South Bend. Enjoy proximity and modern living amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "page_item_url": "apartment-homes-close-to-tuscaloosa-va-medical-center-35405",
      "search_query": "apartment homes close to Tuscaloosa Veterans Affairs Medical Center 35405",
      "category": "Hospital",
      "h1_title": "Nearby Homes to Tuscaloosa VA Medical Center",
      "h2_subtitle": "Seeking apartment homes close to the Tuscaloosa Veterans Affairs Medical Center in 35405? Discover The Gates at South Bend for your ideal living space.",
      "page_copy": "The Gates at South Bend is the perfect choice for those searching for apartment homes close to the Tuscaloosa Veterans Affairs Medical Center. Located within the 35405 area, our community ensures that you can enjoy seamless access to the center without the hassle of a long commute.\n\nOur apartment homes are equipped with modern conveniences like washers and dryers, offering the comfort of home in every unit. Secure access gates and a welcoming community playground add to the appeal, providing residents with an enjoyable living environment. Make The Gates at South Bend your home and enjoy the close proximity to the VA Medical Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-a6ca-76ae-b81f-9fe284348903.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the apartment building.",
        "public_id": "019d54f5-a6ca-76ae-b81f-9fe284348903",
        "storage_key": "property/6767906449167335/019d54f5-a6ca-76ae-b81f-9fe284348903.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Homes Close to Tuscaloosa VA Medical Center",
      "seo_description": "Find apartment homes near Tuscaloosa VA Medical Center at The Gates at South Bend in 35405. Enjoy convenient, comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "page_item_url": "apartments-near-tuscaloosa-river-walk-al",
      "search_query": "apartments near Tuscaloosa River Walk AL",
      "category": "Park",
      "h1_title": "Apartments Near Tuscaloosa River Walk",
      "h2_subtitle": "Discover our charming community close to the Tuscaloosa River Walk in AL. The Gates at South Bend offers comfortable and convenient living.",
      "page_copy": "Experience the best of Tuscaloosa living at The Gates at South Bend, conveniently located near the scenic Tuscaloosa River Walk. Our community offers a unique blend of comfort and accessibility, perfect for those who enjoy serene views and outdoor activities.\n\nEach apartment is designed with modern amenities such as in-unit washers and dryers, creating a hassle-free living experience. The community features secure access gates and a playful playground area, making it suitable for all residents. Enjoy the proximity to the Tuscaloosa River Walk and make The Gates at South Bend your home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-a6ca-76ae-b81f-9fe284348903.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the apartment building.",
        "public_id": "019d54f5-a6ca-76ae-b81f-9fe284348903",
        "storage_key": "property/6767906449167335/019d54f5-a6ca-76ae-b81f-9fe284348903.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Tuscaloosa River Walk AL Apartments Nearby",
      "seo_description": "Explore apartments near Tuscaloosa River Walk in AL at The Gates at South Bend. Enjoy nature and convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "page_item_url": "bowers-park-nearby-apartments-tuscaloosa",
      "search_query": "Bowers Park nearby apartments Tuscaloosa",
      "category": "Park",
      "h1_title": "Apartments Near Bowers Park Tuscaloosa",
      "h2_subtitle": "Looking for apartments near Bowers Park in Tuscaloosa? The Gates at South Bend is just what you need for convenient, modern living.",
      "page_copy": "When it comes to enjoying outdoor fun, living at The Gates at South Bend puts you just minutes away from Bowers Park in Tuscaloosa. Our comfortable apartment community offers easy access to the park, making it perfect for nature lovers and outdoor enthusiasts.\n\nOur apartments feature modern conveniences such as washers and dryers in every unit and secure access gates. The on-site playground ensures that both young residents and adults can enjoy some leisure time. Enjoy the convenience of living near Bowers Park while experiencing the comfort of modern amenities at The Gates at South Bend.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-a6ca-76ae-b81f-9fe284348903.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the apartment building.",
        "public_id": "019d54f5-a6ca-76ae-b81f-9fe284348903",
        "storage_key": "property/6767906449167335/019d54f5-a6ca-76ae-b81f-9fe284348903.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Find Apartments Near Bowers Park Tuscaloosa",
      "seo_description": "Discover nearby apartments to Bowers Park in Tuscaloosa at The Gates at South Bend. Enjoy proximity and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "page_item_url": "park-at-manderson-landing-close-apartments-35405",
      "search_query": "Park at Manderson Landing close apartments 35405",
      "category": "Park",
      "h1_title": "Close Apartments to Park at Manderson Landing",
      "h2_subtitle": "Searching for apartments near Park at Manderson Landing in 35405? Check out The Gates at South Bend for accessible and cozy living.",
      "page_copy": "Enjoy the perfect blend of city life and serene landscapes by choosing The Gates at South Bend for your apartment home close to the Park at Manderson Landing. Nestled in the vibrant 35405 area, our community offers residents quick access to this beautiful park along the Black Warrior River.\n\nOur apartments provide all the comforts of modern living, including washers and dryers, secure access gates, and ground floor units. Families will relish the community playground, offering a great place for relaxation and fun. Live near Manderson Landing and make the most of Tuscaloosa’s natural beauty from your doorstep at The Gates at South Bend.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-a6ca-76ae-b81f-9fe284348903.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the apartment building.",
        "public_id": "019d54f5-a6ca-76ae-b81f-9fe284348903",
        "storage_key": "property/6767906449167335/019d54f5-a6ca-76ae-b81f-9fe284348903.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Park at Manderson Landing Close Apartments",
      "seo_description": "Live near Park at Manderson Landing in 35405 at The Gates at South Bend. Enjoy comfort and accessibility every day.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "page_item_url": "apartments-close-to-snow-hinton-park-tuscaloosa-county",
      "search_query": "apartments close to Snow Hinton Park Tuscaloosa County",
      "category": "Park",
      "h1_title": "Apartments Near Snow Hinton Park",
      "h2_subtitle": "Explore apartments close to Snow Hinton Park in Tuscaloosa County. The Gates at South Bend offers a relaxing and convenient living environment.",
      "page_copy": "Located in the heart of Tuscaloosa County, The Gates at South Bend provides the perfect place to call home near Snow Hinton Park. Our community is ideal for those who love the outdoors and want quick access to one of the area's most popular recreational spaces.\n\nResidents enjoy modern conveniences like in-unit washers and dryers, ensuring everyday chores are a breeze. The secure access gates and inviting playground create a welcoming community. Enjoy the convenience and tranquility of living near Snow Hinton Park at The Gates at South Bend.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-a6ca-76ae-b81f-9fe284348903.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the apartment building.",
        "public_id": "019d54f5-a6ca-76ae-b81f-9fe284348903",
        "storage_key": "property/6767906449167335/019d54f5-a6ca-76ae-b81f-9fe284348903.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Discover Apartments Near Snow Hinton Park",
      "seo_description": "Find your home near Snow Hinton Park in Tuscaloosa County at The Gates at South Bend. Enjoy convenience and community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167335",
      "source": "custom",
      "page_item_url": "government-plaza-adjacent-apartments-tuscaloosa-al",
      "search_query": "Government Plaza adjacent apartments Tuscaloosa AL",
      "category": "Park",
      "h1_title": "Adjacent Apartments to Government Plaza",
      "h2_subtitle": "Looking for apartments adjacent to Government Plaza in Tuscaloosa, AL? The Gates at South Bend offers proximity and modern amenities.",
      "page_copy": "For those looking to live close to the governmental and cultural hub of Tuscaloosa, AL, The Gates at South Bend offers the perfect blend of convenience and comfort. Situated not far from Government Plaza, our community provides easy access to city events, entertainment, and civic activities.\n\nOur apartments boast modern amenities such as in-unit washers and dryers, and secure access gates. The first-floor units provide easy access, while the community playground serves as a delightful retreat. Embrace city living with ease at The Gates at South Bend, where you're just moments away from Government Plaza.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167335/019d54f5-a6ca-76ae-b81f-9fe284348903.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the apartment building.",
        "public_id": "019d54f5-a6ca-76ae-b81f-9fe284348903",
        "storage_key": "property/6767906449167335/019d54f5-a6ca-76ae-b81f-9fe284348903.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Adjacent to Government Plaza",
      "seo_description": "Live conveniently near Government Plaza, Tuscaloosa, AL at The Gates at South Bend. A perfect balance of comfort and city life.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6078"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11671058326"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-MNT6ZL48"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "121dbd11efe62750"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "b484f0cc984e11eebcb40e136090bd39"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "a134dbe2-d0cb-11f0-a5a7-3beae9292400"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "ca6e7a0c-0871-4502-b699-60d5f5cfcb57"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://apollostore.blob.core.windows.net/thegates/uploads/assets/untitled-video-3.c7c30503.mp4"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/ca6e7a0c-0871-4502-b699-60d5f5cfcb57/a134dbe2-d0cb-11f0-a5a7-3beae9292400/tour"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlRhblBJbDY2M0FmcVhTV3ZLMStrd0E9PSIsInZhbHVlIjoiby9VQW4zdTdwSDBBRDhKRDZ6TUY4QT09IiwibWFjIjoiY2NkY2YxZjMwNDQ3ZmYwYzQxODQ2MDM1ODRjOWU1YTU4YjQyMGVhOWI0YjEyZTc4ZGFmYTcxMTg4N2FjNjQ0MyJ9"
    }
  ],
  "custom_qb_id": "6078",
  "custom_repli_id": "11671058326",
  "custom_google_gtm_id": "GTM-MNT6ZL48",
  "custom_knock_community_id": "121dbd11efe62750",
  "custom_knock_company_token": "b484f0cc984e11eebcb40e136090bd39",
  "custom_eliseai_building_token": "a134dbe2-d0cb-11f0-a5a7-3beae9292400",
  "custom_eliseai_organization_id": "ca6e7a0c-0871-4502-b699-60d5f5cfcb57",
  "custom_property_featured_video": "https://apollostore.blob.core.windows.net/thegates/uploads/assets/untitled-video-3.c7c30503.mp4",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/ca6e7a0c-0871-4502-b699-60d5f5cfcb57/a134dbe2-d0cb-11f0-a5a7-3beae9292400/tour",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlRhblBJbDY2M0FmcVhTV3ZLMStrd0E9PSIsInZhbHVlIjoiby9VQW4zdTdwSDBBRDhKRDZ6TUY4QT09IiwibWFjIjoiY2NkY2YxZjMwNDQ3ZmYwYzQxODQ2MDM1ODRjOWU1YTU4YjQyMGVhOWI0YjEyZTc4ZGFmYTcxMTg4N2FjNjQ0MyJ9",
  "custom_audioeye_site_id": "434255a3-bd89-489c-bc4a-7c231dfe5c4c",
  "custom_audioeye_site_hash": "7062ec2c2a14cf2ef1ef34129693d340"
};

export const generatedAt = '2026-10-01T17:24:19.719Z';
